import React, { Component, createRef } from "react"
import PropTypes from "prop-types"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import MetaTags from 'react-meta-tags';
import { withTranslation } from "react-i18next"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import CampaignData from "./Campaign-data"
import classnames from "classnames"
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"
import { Formik, Field, Form, FieldArray, ErrorMessage } from "formik";
import * as Yup from "yup";
import { map } from "lodash"
import { Link } from "react-router-dom"
import {
  getProjectUUIDAction, getProjectWorksheetLead, getProjectWorksheetLeadPurDetail, getProjectWorksheetLeadUnitDetail,
  getProjectWorksheetLeadDocDetail, getProjectWorksheetUnitinfo,
  addActivityProjectFollowUp,
  getActivityProjectFollowUp
} from "../../../store/actions"
import { getProjectLeadCallLog, addProjectLeadCallLog, addProjectLeadEmailLog, getProjectLeadEmailLog, getProjectLeadAct, addProjectleadFollowUp, getProjectLeadFollowUp, addProjectLeadNote, getProjectLeadNote} from "../../../store/actions"
import FileBase64 from "../../../components/Common/FileBase64";
import Flatpickr from "react-flatpickr"
import ProjectSidebar from "../../../components/VerticalLayout/ProjectSidebar";
import Moment from 'react-moment';
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import JoditEditor from 'jodit-react';
import MaskedInput from "react-text-mask";
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import noteImg from "../../../assets/images/rsicons/notes.png";
import follow from "../../../assets/images/rsicons/follow-up.png";
import phonelog from "../../../assets/images/rsicons/phone-log.png";
import emaillog from "../../../assets/images/rsicons/email-log.png";
import moment from "moment-timezone";
import CurrencyInput from "react-currency-input-field";
import Swal from 'sweetalert2';
import worksheetSubmittedIcon from "../../../assets/img/worksheet-submitted-icon.png";
import worksheetPendingIcon from "../../../assets/img/worksheet-pending-icon.png";
import WithdrawnfromClientIcon from "../../../assets/img/worksheet-not-submitted-icon.png";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { MultiSelect } from 'primereact/multiselect';
import {
  Row,
  Col,
  CardBody,
  Card,
  CardText,
  Container,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  FormGroup,
  Label,
  Modal,
   ModalHeader, ModalBody, ModalFooter,
  Input,
  Button,
  Tooltip,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Collapse,
  Alert
} from "reactstrap"
import { isSubmitting } from "redux-form";
import { API_URL } from "helpers/app_url";
import RsLink from "components/buttons/rsLink";
import ActionActivity from "components/buttons/actionActivity";
import TimePicker from "components/dropdowns/Timepicker";
import RichTextEditor from "components/dropdowns/ContentEditor";
import EmailContentEditor from "components/dropdowns/emailContentEditor";
import SafeField from "helpers/SafeField";

class projectSrr extends Component {
  constructor(props) {
    super(props)
    this.state = {
      worksheetLead: '',
      submittedTab: "1",
      manualTab: "1",
      activeTab1: "1",
      activeTab2: "4",
      activeTab: "1",
      activeTab3: "2",
      verticalActiveTab: "1",
      visible: false,
      lead:"",
      isSubmittedData: false,
      isManualData: false,
      isUnitData: false,
      col1: true,
      files: [],
      accordionState: { col0: true },
     showModal: false,
    worksheetStatus: "",       // filter 1
    allotmentStatus: ""        // filter 2

    }



    this.toggleSubmittedCanvas = this.toggleSubmittedCanvas.bind(this);
    this.toggleManualCanvas = this.toggleManualCanvas.bind(this);
    this.toggleUnitCanvas = this.toggleUnitCanvas.bind(this);
    this.handelSubmitMessage = this.handelSubmitMessage.bind(this)
    this.toggle1 = this.toggle1.bind(this);
    this.toggle2 = this.toggle2.bind(this);
    this.t_col1 = this.t_col1.bind(this);
    this.t_col2 = this.t_col2.bind(this);
  
    this.isAllCanavas = this.isAllCanavas.bind(this);
  
    this.toggle3 = this.toggle3.bind(this);
     this.dt = createRef();
  }
  handelSubmitMessage = (value, { resetForm }) => {
      const payload = {
        messageFromId: parseInt(value.messageFromId),
        messageToId: parseInt(value.messageToId),
        messageFrom: value.messageFrom,
        messageTo: value.messageTo,
        messageText: value.messageText,
        agentId: parseInt(value.agentId),
        isActive: true,
      }
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const url = `${API_URL}ProjectCampaignLeadMessage`;
      toast.loading("Please wait...");
      axios
        .post(url, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          if (response.data.success) {
            toast.dismiss();
            toast.success("Saved successfully");
            resetForm();
            this.fetchLeadMessage(value.messageToId);
          } else {
            toast.dismiss();
            toast.error('some issue while sending message');
            console.warn("Submission failed:", response.data);
          }
        })
        .catch((error) => {
          console.error("Error sending message:", error);
  
        });
    }
   fetchLeadMessage(leadId) {
      const { lead } = this.state;
        const obj = JSON.parse(localStorage.getItem("authUser"));
        const token = obj?.resultData?.bearerToken;
        const headers = {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        };
    
        const params = {
          LeadId: leadId,
          agentId: localStorage.getItem('userId')
        };
        axios
          .get(`${API_URL}ProjectCampaignLeadMessage/allLead`, { headers, params })
          .then((response) => {
            this.setState({ leadMessages: response.data, loading: false });
          })
          .catch((error) => {
            this.setState({ error: error.message, loading: false });
          });
      }
   handleFilterChange = (e, type) => {
    this.setState({ [type]: e.target.value });
  };
getFilteredLeads = () => {
    const { worksheetLeads } = this.props; 
    const { worksheetStatus, allotmentStatus } = this.state;

    let filtered = worksheetLeads;

    if (worksheetStatus) {
      filtered = filtered.filter(
        lead => String(lead.leadStatusId) === worksheetStatus
      );
    }

    if (allotmentStatus) {
      filtered = filtered.filter(
        lead => String(lead.unitStatusId) === allotmentStatus
      );
    }

    return filtered;
  };
 toggleModal = () => {
    this.setState({ showModal: !this.state.showModal });
  };
   handlePrint = () => {
    const printContents = document.getElementById("print-content").innerHTML;
    const newWindow = window.open("", "", "width=800,height=600");
    newWindow.document.write(`
      <html><head><title>Print</title></head>
      <body>${printContents}</body></html>
    `);
    newWindow.document.close();
    newWindow.print();
  };
  toggle3(tab) {
    if (this.state.activeTab3 !== tab) {
      this.setState({
        activeTab3: tab,
      });
    }
  }
  toggleAllCanavas(){
    this.setState(prevState => ({
     isAll: !prevState.isAll
   }));
 }
 isAllCanavas() {
  this.setState({ worksheetLead: "",  isAll: !this.state.isAll });
  this.toggleAllCanavas();
}
isAllCanavas = arg => {
  const worksheetLead = arg;
  //console.log(worksheetLead);
  const { onGetFollowLead, onGetNoteLead, onGetLeadCallLog, onGetLeadEmailLog, onGetAllActLead } = this.props;
  this.setState({
    worksheetLead: {
      leadId: worksheetLead.leadId,
      campaignProjectGuid: worksheetLead.campaignProjectGuid,
      agentName: worksheetLead.name,
      email: worksheetLead.email,
      cellPhone: worksheetLead.cellPhone
  },
  });
  //
  //onGetFollowLead(worksheetLead.leadId);
  //onGetNoteLead(worksheetLead.leadId);
  //onGetLeadCallLog(worksheetLead.leadId);
  //onGetLeadEmailLog(worksheetLead.leadId);
  //onGetAllActLead(worksheetLead.leadId)
if(worksheetLead.leadId > 0 ){
  onGetFollowLead(worksheetLead.leadId, worksheetLead.campaignProjectGuid);
  onGetNoteLead(worksheetLead.leadId, worksheetLead.campaignProjectGuid);
  onGetLeadCallLog(worksheetLead.leadId, worksheetLead.campaignProjectGuid);
  onGetLeadEmailLog(worksheetLead.leadId, worksheetLead.campaignProjectGuid);
  onGetAllActLead(worksheetLead.leadId, worksheetLead.campaignProjectGuid)
}
  this.toggleAllCanavas();
};
  getUnitAllocationStatusId = (a) => {

    if (a == 1)
      return "Waiting for Allocation";
    else if (a == 2)
      return "Not Allocated";
    else if (a == 3)
      return "Unit Allocated";
    else if (a == 4)
      return "Withdrawn by Client";
    else
      return "N/A";
  };
  toggleAccordion = (index) => {
    this.setState((prevState) => ({
      accordionState: {
        ...prevState.accordionState,
        [`col${index}`]: !prevState.accordionState[`col${index}`],
      },
    }));
  };
  t_col1() {
    this.setState({
      col1: !this.state.col1,
      col2: false,

    });
  }

  t_col2() {
    this.setState({
      col1: false,
      col2: !this.state.col2,

    });
  }
  toggle1(tab) {
    if (this.state.activeTab1 !== tab) {
      this.setState({
        activeTab1: tab,
      });
    }
  }

  toggle2(tab) {
    if (this.state.activeTab2 !== tab) {
      this.setState({
        activeTab2: tab,
      });
    }
  }
  getFiles(files) {
    this.setState({ files: files })
    //

  }
  toggleSubmit() {

    this.setState({ isSubmittedData: !this.state.isSubmittedData });

  }
  toggleManual() {

    this.setState({ isManualData: !this.state.isManualData });

  }
  toggleUnit() {

    this.setState({ isUnitData: !this.state.isUnitData });

  }
  tog_standard() {
    this.setState(prevState => ({
      modal_standard: !prevState.modal_standard,
    }))
    this.removeBodyCss()
  }

  removeBodyCss() {
    document.body.classList.add("no_padding")
  }


  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      })
    }
  }
  toggleSubmittedCanvas() {
    this.setState({ worksheetLead: '', isSubmittedData: !this.state.isSubmittedData });
    this.toggleSubmit();
  }
  toggleSubmittedCanvas = arg => {
    const worksheetLead = arg;
    const { onGetProjectWorksheetLeadPurDetail, onGetProjectWorksheetLeadUnitDetail, onGetProjectWorksheetLeadDocDetail, onGetProjectWorksheetUnitinfo } = this.props;
    this.setState({
      worksheetLead: {
        id: worksheetLead.id,
        unitStatusId: worksheetLead.unitStatusId,
        filledDate: worksheetLead.filledDate,
        projectCampaignLeadId: worksheetLead.projectCampaignLeadId,
        isLockerRequired:worksheetLead.isLockerRequired,
        isParkingRequired:worksheetLead.isParkingRequired
      }
    });
    //
    onGetProjectWorksheetLeadPurDetail(worksheetLead.id);
    onGetProjectWorksheetLeadUnitDetail(worksheetLead.id);
    onGetProjectWorksheetLeadDocDetail(worksheetLead.id);
    onGetProjectWorksheetUnitinfo(worksheetLead.id)
    this.toggleSubmit();
  };
  toggleManualCanvas() {
    this.setState({ worksheetLead: '', isManualData: !this.state.isManualData });
    this.toggleManual();
  }

  toggleManualCanvas = arg => {
    const worksheetLead = arg;
    this.setState({
      worksheetLead: {
        projectLeadWorkSheetId: worksheetLead.projectLeadWorkSheetId,
        projectCampaignLeadId: worksheetLead.projectCampaignLeadId,

      }
    });
    
    this.toggleManual();
  }


  toggleUnitCanvas() {
    this.setState({ worksheetLead: '', isUnitData: !this.state.isUnitData });
    this.toggleUnit();
  }
  toggleUnitCanvas = arg => {
    const worksheetLead = arg;
    const { onGetProjectWorksheetLeadUnitDetail, onGetProjectWorksheetUnitinfo } = this.props;
    this.setState({
      worksheetLead: {
        id: worksheetLead.id,

      }
    });
    // 
    onGetProjectWorksheetLeadUnitDetail(worksheetLead.id);
    onGetProjectWorksheetUnitinfo(worksheetLead.id)
    this.toggleUnit();
  };
  componentDidMount() {

    const { match: { params }, ongetProjectUUIDAction, onGetProjectWorksheetLead } = this.props;

    if (params && params.projectId) {
      ongetProjectUUIDAction(params.projectId);
      onGetProjectWorksheetLead(params.projectId, 0);
    }
  }
  removeEmptyPurchasers = (data) => {
    return data.filter(item => item.firstName.trim() !== '' || item.lastName.trim() !== '');
  }
  removeEmptySheetAllocationList = (data) => {
    return data.filter(item => item.insideSqFt !== '' || item.outsideSqFt !== '');
  }
  handleSubmit = (values, { setSubmitting }) => {
    const cleanedData = {
      ...values,
      createProjectLeadWorkSheetPurchaserList: this.removeEmptyPurchasers(values.createProjectLeadWorkSheetPurchaserList),
    };

    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj.resultData.bearerToken;
    const str = 'Bearer ' + token;
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': str
    };

    toast.loading("Please wait...");
    axios.put(`${API_URL}ProjectLeadWorkSheet`, cleanedData, { headers })
      .then(response => {
        toast.dismiss();
        if (response.data.success) {
          toast.success("Worksheet Form Saved");
          
        } else {
          toast.warn(response.validationErrors[0]);
        }
      })
      .catch(error => {
        toast.dismiss();
        console.error('Error:', error);
      });
    //        
    setSubmitting(false);
  }

 handleClearProject = (worksheetLead) => {
  Swal.fire({
    title: 'Are you sure?',
    text: "This will clear the project worksheet. Do you want to continue?",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, clear it!'
  }).then((result) => {
    if (result.isConfirmed) {
      const cleanedData = {
        projectCampaignLeadId: worksheetLead.projectCampaignLeadId,
      };

      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj.resultData.bearerToken;
      const str = 'Bearer ' + token;
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': str
      };

      toast.loading("Please wait...");
      axios.put(`${API_URL}ProjectWorkSheet/ClearProjectWorkSheet`, cleanedData, { headers })
        .then(response => {
          toast.dismiss();
          if (response.data.success) {
            toast.success("Clear Project Saved");
            //
          } else {
            toast.warn(response.validationErrors[0]);
          }
        })
        .catch(error => {
          toast.dismiss();
          console.error('Error:', error);
          toast.error("An error occurred while clearing the project.");
        });
    }
  });
}
   handleStartTime = (setFieldValue, values) => {
          const { startHrs, startMin, startDif } = values;
          const hours = parseInt(startHrs, 10);
          const minutes = parseInt(startMin, 10);
          const meridiem = startDif === 'PM' && hours < 12 ? hours + 12 : hours;
          const date = new Date();
          const formattedTime = moment()
            .set({ hour: meridiem, minute: minutes })
            .format('YYYY-MM-DDTHH:mm:ss.SSSZ');
          setFieldValue('startTime', formattedTime);
      
        };
      
        handleEndTime = (setFieldValue, values) => {
          const { endHrs, endMin, endDif } = values;
          const hours = parseInt(endHrs, 10);
          const minutes = parseInt(endMin, 10);
          const meridiem = endDif === 'PM' && hours < 12 ? hours + 12 : hours;
          const date = new Date();
          const formattedTime = moment()
            .set({ hour: meridiem, minute: minutes })
            .format('YYYY-MM-DDTHH:mm:ss.SSSZ');
          setFieldValue('endTime', formattedTime);
      
        };
   handleFollowPlaceSelected = (address, setFieldValue) => {
          geocodeByAddress(address)
            .then(results => {
              const place = results[0];
              const addressComponents = place.address_components;
              
              const getComponent = (types) => {
                const component = addressComponents.find((component) =>
                  types.every((type) => component.types.includes(type))
                );
                return component ? component.long_name : '';
              };
              const latitude = place.geometry.location.lat();
              const longitude = place.geometry.location.lng();
              setFieldValue('activityLocation', place.formatted_address);
              setFieldValue('activityLatitude', longitude);
              setFieldValue('activityLongitude', latitude);
            })
            .catch(error => console.error('Error', error));
        };
  

  handleSelectChange = (e) => {
    this.props.history.push(e.target.value);
  };
  render() {
    const { projectData, worksheetLeads, worksheetPurData, worksheetUnitData, worksheetDocData, unitdata, onGetProjectWorksheetLead, onAddLeadNote, onAddLeadFollowUp, onAddCallLog, onAddEmailLog } = this.props;
    const { notes, followups, calllogs, emaillogs, activities, leadFollows, isResponsive, onGetAllActLead } = this.props;
    const { isEdit, isEditFollow, isEditCall, lead, leadMessages } = this.state;
    const worksheetLead = this.state.worksheetLead;
    const allLocal = localStorage.getItem('localData')
    const localization = JSON.parse(allLocal);
    const filteredLeads = this.getFilteredLeads();
const { projectId } = this.props.match.params;
const tabs = [
      {
        id: "project-leads",
        label: "Project Leads",
        link: `/pre-construction/campaign/current-prospects/${projectId}`
      },
      {
        id: "worksheets",
        label: "Worksheets",
        link: `/pre-construction/campaign/srr-filled/${projectId}`
      },
      {
        id: "clients",
        label: "Clients",
        link: `/pre-construction/campaign/client/${projectId}`
      }
    ];
const currentPath = this.props.location.pathname;
 const agentNameTemplate = (rowData) => (
    <div className="d-flex align-items-center">
      <img
        src={
          rowData.leadStatusId === 3 && rowData.unitStatusId !== 4
            ? worksheetSubmittedIcon
            : rowData.unitStatusId === 4
            ? WithdrawnfromClientIcon
            : worksheetPendingIcon
        }
        alt="status"
        style={{ height: 20 }}
        className="me-2"
      />
      {rowData.agentName}
    </div>
  );   
const nameTemplate = (rowData) => (
    <div className="d-flex align-items-center">
      
      {rowData.name}
    </div>
  );
  const emailTemplate = (rowData) => rowData.email?.toLowerCase();
  const dateSendTemplate = (rowData) =>
    rowData.filledDate ? (
      <Moment format="D MMM YY">{rowData.filledDate}</Moment>
    ) : (
      ""
    );
  const dateSubmittedTemplate = (rowData) =>
    rowData.filledDate ? (
      <Moment format="D MMM YY">{rowData.filledDate}</Moment>
    ) : (
      ""
    );

  
  const allotmentStatusTemplate = (rowData) =>
    this.getUnitAllocationStatusId(rowData.unitStatusId);


  const actionTemplate = (rowData) => (
    <>
      <ActionActivity onClick={() => this.isAllCanavas(rowData)} />
      {rowData.leadStatusId === 3 ? (
        <RsLink
          className="btn btn-action" iconClass=""
          onClick={() => this.toggleSubmittedCanvas(rowData)}
        >
          Manage
        </RsLink>
      ) : (
        <RsLink className="btn btn-light" iconClass="" disabled>
          Manage
        </RsLink>
      )}
    </>
  );
const unitSatatusOptions = [
  { label: "Waiting for Allocation", value: 2 }, 
  { label: "Not Allocated", value: 1 },       
  { label: "Unit Allocated", value: 3 },   
  { label: "Withdrawn by Client", value: 4 }, 
  { label: "N/A", value: 0 },   
];
const unitSatatusFilterTemplate = (options) => {
  return (
    <MultiSelect
      value={options.value}
      options={unitSatatusOptions}
      onChange={(e) => options.filterApplyCallback(e.value)}
      placeholder="Select status"
      className="p-column-filter"
      display="chip"
      showClear
    />
  );
};
console.log(worksheetLead);
    return (
      <React.Fragment>
        {this.props.loading && this.props.loading ? (
          <div className="loading">Loading&#8230;</div>
        ) : null}
        <ToastContainer autoClose={2000} />
        <div className="page-content project-page-content">

          <MetaTags>
            <title>Campaigns | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0 ">
            <Row>
              <Col sm='2' className="pe-0" >
                <ProjectSidebar isResponsive={isResponsive} />
              </Col>
              <Col sm='10' className="ps-0">
                <Row className="project-header">
                  <Col sm="7">
                    <Breadcrumbs title={this.props.t("Projects")} breadcrumbItem={this.props.t("Activity")} />
                  </Col>
                  <Col sm="4">
                    <h2 className="">{this.props.t(projectData.projectName)}</h2>
                  </Col>
                </Row>

                <Row>
                  <Col lg="6">
                   {isResponsive ? (
                                      <Card>
                                        <CardBody>
                                          <h6>Select Menu</h6>
                                            <select
                              className="form-select mb-3"
                              value={currentPath}
                              onChange={this.handleSelectChange}
                            >
                              {tabs.map((tab) => (
                                <option key={tab.id} value={tab.link}>
                                  {tab.label}
                                </option>
                              ))}
                            </select>
                                        </CardBody>
                                      </Card>
                                    ):(
                                       <Nav tabs className="projectTab projectNav">
                                      
                                                            <NavItem>
                                                              <Link className="nav-link " to={"/pre-construction/campaign/current-prospects/" + this.props.match.params.projectId}
                                      
                                                              >
                                                                <span className="d-none d-sm-block">{this.props.t("Office Leads")}</span>
                                      
                                                              </Link>
                                                            </NavItem>
                                                             <NavItem>
                                                              <Link className="nav-link" to={"/pre-construction/campaign/transferred/" + this.props.match.params.projectId}
                                      
                                                              >
                                                                <span className="d-none d-sm-block">{this.props.t("Transferred Lead")}</span>
                                      
                                                              </Link>
                                                            </NavItem>
                                                            <NavItem>
                                                              <Link className="nav-link active" to={"/pre-construction/campaign/srr-filled/" + this.props.match.params.projectId}
                                      
                                                              >
                                                                <span className="d-none d-sm-block">{this.props.t("Worksheets")}</span>
                                      
                                                              </Link>
                                                            </NavItem>
                                      
                                                            <NavItem>
                                                              <Link className="nav-link" to={"/pre-construction/campaign/client/" + this.props.match.params.projectId}
                                      
                                                              >
                                                                <span className="d-none d-sm-block">{this.props.t("Clients")}</span>
                                      
                                                              </Link>
                                                            </NavItem>
                                                          </Nav>
                    )}
                  </Col>
                  
                </Row>

                <Row>

                  <Col lg="12">

                    <Card>
                   
                      <CardBody>
   <Row>
                          <Col lg="6" className="">
                                 {!isResponsive && (
                                  <div className="mb-3">
                                      <div className="d-flex gap-4">
                                          <span>
                                              <img src={worksheetSubmittedIcon} alt="status" style={{ height: 20 }} className="me-1" />
                                              <span>{this.props.t("Worksheet submitted")}</span>
                                          </span>
                                          <span>
                                              <img src={worksheetPendingIcon} alt="status" style={{ height: 20 }} className="me-1" />
                                              <span>{this.props.t("Worksheet pending")}</span>
                                          </span>
                                          <span>
                                              <img src={WithdrawnfromClientIcon} alt="status" style={{ height: 20 }} className="me-1" />
                                              <span>{this.props.t("Withdrawn from client")}</span>
                                          </span>
                                      </div>
                                  </div>
                                 )}
                    </Col>
                      </Row>
                       {isResponsive ? (
                        <DataTable
    value={filteredLeads}
    paginator
    rows={10}
    className="p-datatable-striped"
    responsiveLayout="scroll"
    expandedRows={this.state.expandedRows}
    onRowToggle={(e) => this.setState({ expandedRows: e.data })}
    rowExpansionTemplate={(rowData) => (
      <table className="table table-sm mb-0 bg-light">
        <tbody>
          <tr>
            <th>Date Send</th>
            <td>{
                rowData.filledDate ? (
                 <Moment format="D MMM YY">{rowData.filledDate}</Moment>
             ) : (
                  ""
             )
              }</td>
          </tr>
          <tr>
            <th>Date Submitted</th>
            <td>{
                rowData.filledDate ? (
      <Moment format="D MMM YY">{rowData.filledDate}</Moment>
    ) : (
      ""
    )
              }</td>
          </tr>
          <tr>
            <th>Allotment Status</th>
            <td>{this.getUnitAllocationStatusId(rowData.unitStatusId)}</td>
          </tr>
         
        </tbody>
      </table>
    )}
  >
    {/* Expander column */}
    <Column expander style={{ width: "3rem" }} />
  <Column
                        header="#"
                        body={(rowData, options) => options.rowIndex + 1}
                        style={{ width: '60px' }}
                      />
    {/* Compact info */}
    <Column
      field="name"
      header="Name"
      body={(rowData) => (
        <div>
          <strong>{rowData.name}</strong>
          <div className="text-muted small">{rowData.email}</div>
        </div>
      )}
    />

    <Column
      header="Action"
      body={(rowData) => actionTemplate(rowData)}
    />
  </DataTable>
                       ):(
                            <DataTable
                        value={filteredLeads}
                          ref={this.dt}
                        className="p-datatable-striped p-datatable-bordered"
                        responsiveLayout="scroll"
                        paginator
                        rows={10}
                      >
                         <Column
                        header="#"
                        body={(rowData, options) => options.rowIndex + 1}
                        style={{ width: '60px' }}
                      />
                      <Column header={this.props.t("Agent Name")} body={agentNameTemplate}
                          field="agentName"
                          filter
                          filterPlaceholder=""
                          showFilterMatchModes={false}  
                          showFilterOperator={false}     
                          showAddButton={false}       
                          showClearButton={false}      
                        />
                        <Column header={this.props.t("Name")} body={nameTemplate}
                          field="name"
                          filter
                          filterPlaceholder=""
                          showFilterMatchModes={false}  
                          showFilterOperator={false}     
                          showAddButton={false}       
                          showClearButton={false}      
                        />
                        <Column header={this.props.t("Email")} body={emailTemplate}
                          field="email"
                          filter
                          filterPlaceholder=""
                          showFilterMatchModes={false}  
                          showFilterOperator={false}     
                          showAddButton={false}       
                          showClearButton={false} 
                        
                        />
                        <Column header={this.props.t("Date Send")} body={dateSendTemplate} />
                        <Column header={this.props.t("Date Submitted")} body={dateSubmittedTemplate} />
                        <Column header={this.props.t("Allotment Status")} body={allotmentStatusTemplate}
                        
                           filter
                        filterElement={unitSatatusFilterTemplate}
                        filterField="unitStatusId"
                        filterMatchMode="in"    
                        filterDisplay="menu"
                         showFilterMatchModes={false}  
                          showFilterOperator={false}     
                          showAddButton={false}       
                          showClearButton={false}     

                        />
                        <Column 
                          headerClassName="action-header" 
                        header={
                                        <div className="justify-content-end">
                                          <RsLink
                                            onClick={() => this.dt.current.reset()}
                                            iconClass="bx bx-reset"
                                            className="btn-light"
                                          >
                                            Reset all filters
                                          </RsLink>
                                        </div>
                                      }
                        body={actionTemplate} />
                      </DataTable>
                       )}

                    








                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Offcanvas
              isOpen={this.state.isAll}
              direction="end"
              toggle={this.isAllCanavas}
              style={{ width: 800 }}
s
            >
              <OffcanvasHeader className="submittedWorksheet" toggle={this.isAllCanavas}>
                 Activities                     
              </OffcanvasHeader>
              <OffcanvasBody>
                <Nav pills className="navtab-bg nav-justified">
                <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab3 === "2",
                      })}
                      onClick={() => {
                        this.toggle3("2");
                        onGetAllActLead(worksheetLead?.leadId, worksheetLead?.campaignProjectGuid)
                      }}
                    >
                     All Activities
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab3 === "1",
                      })}
                      onClick={() => {
                        this.toggle3("1");
                      }}
                    >
                      Follow Up
                    </NavLink>
                  </NavItem>
                 
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab3 === "3",
                      })}
                      onClick={() => {
                        this.toggle3("3");
                        this.fetchLeadMessage(worksheetLead?.leadId);
                      }}
                    >
                      Message
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab3 === "4",
                      })}
                      onClick={() => {
                        this.toggle3("4");
                      }}
                    >
                      Add Notes
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab3 === "5",
                      })}
                      onClick={() => {
                        this.toggle3("5");
                      }}
                    >
                      Call Log
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab3 === "6",
                      })}
                      onClick={() => {
                        this.toggle3("6");
                      }}
                    >
                      Email Log
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent
                  activeTab={this.state.activeTab3}
                  className="p-3 text-muted"
                >
                  <TabPane tabId="1">
                      <div className="tabContent">
                         <Formik
                                            enableReinitialize={true}
                                            initialValues={{
                                              agentId: parseInt(localStorage.getItem("userId")),
                                              title: "Call-Follow Up",
                                            contactname: worksheetLead.agentName,
                                          contactphone: worksheetLead.cellPhone,
                                          contactemail: worksheetLead.email,
                                          //addedDate: new Date(),
                                          activityStartDate: new Date(),
                                          startTime: "",
                                          endTime: "",
                                          activityStatus: 1,
                                          activityType: 3,
                                          activityRefId: worksheetLead.leadId,
                                          activityDescription: (this.state && this.state.activityDescription) || "",
                                          activityLocationType: 3,
                                          activityLocation: "",
                                          activityParentRefGuid:worksheetLead.campaignProjectGuid, 
                                          activityParentRefTypeId:worksheetLead.campaignProjectId,
                                              isActive: true,
                                              category: 3
                                            }}
                                            validationSchema={Yup.object().shape({
                                              activityDescription: Yup.string().required("This is Required"),
                                              startTime: Yup.string().when('activityType', {
                                                  is: 1,
                                                  then: Yup.string().required("Start time is required"),
                                                  otherwise: Yup.string().nullable()
                                                }),
                        
                                                endTime: Yup.string().when('activityType', {
                                                  is: 1,
                                                  then: Yup.string().required("End time is required"),
                                                  otherwise: Yup.string().nullable()
                                                })
                                            })}
                                            onSubmit={(values,  { resetForm }) => {
                                              const formattedValues = {
                                                ...values,
                                                activityStartDate: moment(values.activityStartDate).format('YYYY-MM-DD'),
                        
                                              };
                                              onAddLeadFollowUp(formattedValues);
                                              onGetAllActLead(lead.leadId, lead?.project?.projectGuid)
                        
                                            }}
                        
                                          >
                                            {({ errors, touched, values, handleChange, setFieldValue, setFieldTouched }) => (
                                              <Form
                                                className="needs-validation"
                                              >
                        
                                                <Row>
                                                  <Col md="12">
                                                    <FormGroup className="mb-3">
                        
                                                      <div className="clearfix"></div>
                                                      <div className="btn-group" role="group">
                                                        <SafeField type="radio" className="btn-check"
                                                          name="activityType" id="btnradio4"
                                                          value={3}
                                                          checked={values.activityType === 3}
                                                          onChange={() => {
                                                            setFieldValue("activityType", 3)
                                                            setFieldValue("title", "Call Log")
                                                          }}
                                                          autoComplete="off" />
                                                        <label className="btn btn-outline-secondary" htmlFor="btnradio4">Call</label>
                        
                                                        <SafeField type="radio" className="btn-check" name="activityType" id="btnradio5" value={12}
                                                          checked={values.activityType === 12}
                        
                                                          onChange={() => {
                                                            setFieldValue("activityType", 12)
                                                            setFieldValue("title", "Message")
                                                          }}
                        
                                                          autoComplete="off" />
                                                        <label className="btn btn-outline-secondary" htmlFor="btnradio5">Message</label>
                        
                                                        <SafeField type="radio" className="btn-check" name="activityType" id="btnradio6"
                                                          value={4}
                                                          checked={values.activityType === 4}
                        
                                                          onChange={() => {
                                                            setFieldValue("activityType", 4)
                                                            setFieldValue("title", "Email")
                                                          }}
                                                          autoComplete="off" />
                                                        <label className="btn btn-outline-secondary" htmlFor="btnradio6">Email</label>
                                                        
                                                        <SafeField type="radio" className="btn-check" name="activityType" id="btnradio7" value={1}
                                                          checked={values.activityType === 1}
                        
                                                          onChange={() => {
                                                            setFieldValue("activityType", 1)
                                                            setFieldValue("title", "Meeting")
                                                          }}
                        
                                                          autoComplete="off" />
                                                        <label className="btn btn-outline-secondary" htmlFor="btnradio7">Meeting</label>


                                                        <SafeField type="radio" className="btn-check" name="activityType" id="btnradio8" value={2}
                                                          checked={values.activityType === 2}
                        
                                                          onChange={() => {
                                                            setFieldValue("activityType", 2)
                                                            setFieldValue("title", "Task")
                                                          }}
                        
                                                          autoComplete="off" />
                                                        <label className="btn btn-outline-secondary" htmlFor="btnradio8">Task</label>
                        
                        
                                                      </div>
                                                      <ErrorMessage
                                                        name="activityType"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                                                  <Col md="12">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="activityDescription">
                                                        {this.props.t("Description *")}
                                                      </Label>
                                                      <SafeField
                                                        name="activityDescription"
                                                        onChange={handleChange}
                                                        as="textarea"
                                                        className={
                                                          "form-control" +
                                                          (errors.activityDescription && touched.activityDescription
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="activityDescription"
                                                      />
                                                      <ErrorMessage
                                                        name="activityDescription"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                        
                                                  <Col md="12">
                                                    <FormGroup className="mb15">
                        
                                                      <Label htmlFor="activityStartDate">
                                                        Date
                                                      </Label>
                                                      <Flatpickr
                                                        className={
                                                          "form-control" +
                                                          (errors.activityStartDate && touched.activityStartDate
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        placeholder=""
                                                        value={values.activityStartDate}
                                                        onChange={(value) => setFieldValue('activityStartDate', value[0])}
                                                        options={{
                                                          altInput: true,
                                                          altFormat: "F j, Y",
                                                          dateFormat: "Y-m-d"
                                                        }}
                                                      />
                                                      <ErrorMessage
                                                        name="logDate"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                        
                                                  </Col>
                                                </Row>
                                                 { values.activityType === 1 && (
                                                                    <>
                                                                    <Row>
                                                                    <Col md="6">
                                                                     <TimePicker
                                                                      name="startTime"
                                                                      label="Start Time *"
                                                                      value={values.startTime}
                                                                      onChange={(val) => setFieldValue("startTime", val)}
                                                                      onBlur={() => setFieldTouched("startTime", true)}
                                                                      minTime={null}
                                                                      error={errors.startTime}
                                                                      touched={touched.startTime}
                                                                    />
                                                                     
                                                                    </Col>
                                                                    <Col md="6">
                                                                     <TimePicker
                                                                      name="endTime"
                                                                      label="End Time *"
                                                                      value={values.endTime}
                                                                      onChange={(val) => setFieldValue("endTime", val)}
                                                                      onBlur={() => setFieldTouched("endTime", true)}
                                                                      minTime={values.startTime}
                                                                      disabled={!values.startTime}
                                                                      error={errors.endTime}
                                                                      touched={touched.endTime}
                                                                    />
                                                                   
                                                                    </Col>
                                                      <Col md="12">
                                                        <FormGroup className="mb-3">
                                                          <Label htmlFor="notes">
                                                            {this.props.t("Location")}
                                                          </Label>
                                                          <div className="clearfix"></div>
                                                          <div className="btn-group" role="group">
                        
                                                            <SafeField type="radio" className="btn-check" name="activityLocationType" id="btnradio91"  value={3}
                                                            onChange={() => setFieldValue("activityLocationType", 3)}
                                                            autoComplete="off" />
                                                            <label className="btn btn-outline-secondary" htmlFor="btnradio91">In-person</label>
                                                            <SafeField type="radio" className="btn-check" name="activityLocationType" id="btnradio101" value={1}
                                                            onChange={() => setFieldValue("activityLocationType", 1)}
                                                            autoComplete="off" />
                                                            <label className="btn btn-outline-secondary" htmlFor="btnradio101">Online</label>
                                                          </div>
                        
                                                        </FormGroup>
                                                      </Col>
                        
                                                      <Col md="12">
                                                        <FormGroup className="mb-3">
                                                          <Label htmlFor="addressLine1">
                                                            {this.props.t("Location")}
                                                          </Label>
                                                          {values.activityLocationType === 3 ? (
                                                            <PlacesAutocomplete
                                                              value={values.activityLocation}
                                                              onChange={(value) => setFieldValue('activityLocation', value)}
                                                              onSelect={(value) => this.handleFollowPlaceSelected(value, setFieldValue)}
                                                            >
                                                              {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                                                <div>
                                                                  <input
                                                                    {...getInputProps({
                                                                      placeholder: 'Enter Address...',
                                                                      className: 'form-control',
                        
                                                                    })}
                                                                  />
                                                                  <div className="">
                                                                    {loading ? <div>Loading...</div> : null}
                        
                                                                    {suggestions.map((suggestion, i) => {
                                                                      const className = suggestion.active
                                                                        ? 'suggestion-item--active'
                                                                        : 'suggestion-item';
                                                                      const style = suggestion.active
                                                                        ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                                                        : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };
                        
                                                                      return (
                                                                        <div
                                                                          key={i}
                                                                          {...getSuggestionItemProps(suggestion, {
                                                                            style,
                                                                          })}
                                                                        >
                                                                          {suggestion.description}
                                                                        </div>
                                                                      );
                                                                    })}
                                                                  </div>
                                                                </div>
                                                              )}
                                                            </PlacesAutocomplete>
                                                          ) : (
                                                            <SafeField
                                                              name="activityLocation"
                                                              onChange={handleChange}
                                                              type="text"
                                                              className={
                                                                "form-control" +
                                                                (errors.activityLocation && touched.activityLocation
                                                                  ? " is-invalid"
                                                                  : "")
                                                              }
                                                              id="activityLocation"
                        
                                                            />
                                                          )}
                                                        </FormGroup>
                                                      </Col>
                                                                    </Row>
                                                                    </>
                                                                    )}
                                                <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>
                        
                        
                                              </Form>
                                            )}
                                          </Formik>
                        
                 
                  <div className="mb-5 h4 card-title mt-20">Follow-up History</div>
                  <ul className="verti-timeline list-unstyled">

                    {map(leadFollows, (follLog, follLogkey) => (

                      <li className="event-list eventlist" key={"_note_" + follLogkey}>
                        <div className="event-timeline-dot">
                          <i className="bx bx-right-arrow-circle font-size-18" />
                        </div>
                        <div className="d-flex">
                          <div className="flex-shrink-0 me-3">
                            <h5 className="font-size-14">
                              <Moment format="D MMM YY">{follLog.activityStartDate}</Moment>


                            </h5>
                          </div>
                          <div className="flex-grow-1">
                            <h5 className="font-size-14"></h5>
                          </div>
                        </div>
                        <div className="exNote">{follLog.activityDetails		}</div>
                      </li>
                    ))}

                  </ul>
                
                      </div>
                  </TabPane>
                  <TabPane tabId="2">
                    <div className="tabContent">
                    <ul className="verti-timeline list-unstyled">
                                        {map(
                                          activities,
                                          (allactivity, allactkey) => (
                                            <li
                                              className="event-list eventlist"
                                              key={"_allact_" + allactkey}
                                            >
                                              <div className="event-timeline-dot">
                                                {(() => {
                                                  if (
                                                    allactivity.activitySubType ==
                                                      8 ||
                                                    allactivity.activitySubType ==
                                                      9 ||
                                                    allactivity.activitySubType ==
                                                      7
                                                  ) {
                                                    return (
                                                      <>
                                                        <img src={emaillog} />
                                                      </>
                                                    );
                                                  } else if (
                                                    allactivity.activitySubType ==
                                                      3 ||
                                                    allactivity.activitySubType ==
                                                      4 ||
                                                    allactivity.activitySubType ==
                                                      5
                                                  ) {
                                                    return (
                                                      <>
                                                        <img src={phonelog} />
                                                      </>
                                                    );
                                                  } else if (
                                                    allactivity.activitySubType ==
                                                    10
                                                  ) {
                                                    return (
                                                      <>
                                                        <img src={follow} />
                                                      </>
                                                    );
                                                  } else {
                                                    return (
                                                      <>
                                                        <img src={noteImg} />
                                                      </>
                                                    );
                                                  }
                                                })()}
                                              </div>
                                              <div className="d-flex">
                                                <div className="flex-shrink-0 me-3">
                                                  <h5 className="font-size-14">
                                                    <Moment format="D MMM YY">
                                                      {allactivity.addedDate}
                                                    </Moment>
                                                  </h5>
                                                </div>
                                                <div className="flex-grow-1">
                                                  <h5 className="font-size-14">
                                                    {
                                                      localization[
                                                        "ActivitySubType_" +
                                                          allactivity.activityType +
                                                          "_" +
                                                          allactivity.activitySubType
                                                      ]
                                                    }
                                                  </h5>
                                                </div>
                                              </div>
                                              <div className="exNote">
                                                {allactivity.activityRemarks}
                                              </div>
                                            </li>
                                          )
                                        )}
          </ul>
                    </div>
                  </TabPane>

                  <TabPane tabId="3">
                    <div className="tabContent">
                                     <Formik
                                       enableReinitialize={true}
                                       initialValues={{
                   
                                       
                                         messageFromId:localStorage.getItem("userId"),
                                         messageToId:worksheetLead?.leadId,
                                         messageFrom:'Realtor',
                                         messageTo:'lead',
                                         agentId: localStorage.getItem('userId'),
                                         messageText: "",
                   
                   
                   
                                       }}
                                       validationSchema={Yup.object().shape({
                                         messageText: Yup.string().required("This is Required")
                                       })}
                   
                                       onSubmit={this.handelSubmitMessage}
                                     >
                                       {({ errors, touched, values, handleChange, setFieldValue }) => (
                                         <Form
                                           className="needs-validation"
                                         >
                   
                                           <Row>
                                             <Col md="12">
                                               <FormGroup className="mb-3">
                                                 <Label htmlFor="messageText">
                                                   {this.props.t("Send Message *")}
                                                 </Label>
                                                 <SafeField
                                                   name="messageText"
                                                   onChange={handleChange}
                                                   as="textarea"
                                                   className={
                                                     "form-control" +
                                                     (errors.messageText && touched.messageText
                                                       ? " is-invalid"
                                                       : "")
                                                   }
                                                   id="messageText"
                                                 />
                                                 <ErrorMessage
                                                   name="messageText"
                                                   component="div"
                                                   className="invalid-feedback"
                                                 />
                                               </FormGroup>
                                             </Col>
                                           </Row>
                                           <div className="clearfix"><button type="submit" className="btn btn-primary w-md">{this.props.t("Send")}</button></div>
                   
                   
                                         </Form>
                                       )}
                                     </Formik>
                                    
                   
                   
                                         {leadMessages && leadMessages.length > 0 ? (
                                                                                                     <>
                                       <div className="mb-5 h4 card-title mt-20">Message History</div>
                                       <ul className="verti-timeline list-unstyled">
                   
                                         {map(leadMessages, (noteLog, notekey) => (
                   
                                           <li className="event-list eventlist" key={"_note_" + notekey}>
                                             <div className="event-timeline-dot">
                                               <i className="bx bx-right-arrow-circle font-size-18" />
                                             </div>
                                             <div className="d-flex">
                                               <div className="flex-shrink-0 me-3">
                                                 <h5 className="font-size-14">
                                                   <Moment format="D MMM YY">{noteLog.createdDate}</Moment>
                   
                   
                                                 </h5>
                                               </div>
                                               <div className="flex-grow-1">
                                                 <h5 className="font-size-14"></h5>
                                               </div>
                                             </div>
                                             <div className="exNote">{noteLog.messageText}</div>
                                           </li>
                                         ))}
                   
                                       </ul>
                                       </>
                                 ) : null }
                   
                                   </div>
                  </TabPane>
                  <TabPane tabId="4">
                    <div className="tabContent">
                    <Formik
              enableReinitialize={true}
              initialValues={{

                refId: worksheetLead.leadId,
                remarks:"",
                addedDate:new Date(),
                addedBy: parseInt(localStorage.getItem('userId')),
                activityParentRefId:worksheetLead.leadId,
                activityParentRefGuid:worksheetLead.campaignProjectGuid

              }}
              validationSchema={Yup.object().shape({
                remarks: Yup.string().required("This is Required")
              })}

              onSubmit={values => {
                  onAddLeadNote(values)
                  //this.toggleAllCanavas();
            }}
            >
              {({ errors, touched, values, handleChange, setFieldValue }) => (
                <Form
                  className="needs-validation"
                >

                  <Row>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="remarks">
                          {this.props.t("Add Note *")}
                        </Label>
                        <SafeField
                          name="remarks"
                          onChange={handleChange}
                          as="textarea"
                          className={
                            "form-control" +
                            (errors.remarks && touched.remarks
                              ? " is-invalid"
                              : "")
                          }
                          id="remarks"
                        />
                        <ErrorMessage
                          name="remarks"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <div className="clearfix"><button type="submit" className="btn btn-primary w-md">{this.props.t("Save")}</button></div>


                </Form>
              )}
            </Formik>
            <div className="mb-5 h4 card-title mt-20">Notes History</div>
                                <ul className="verti-timeline list-unstyled">

                                  {map(notes, (noteLog, notekey) => (

                                    <li className="event-list eventlist" key={"_note_" + notekey}>
                                      <div className="event-timeline-dot">
                                        <i className="bx bx-right-arrow-circle font-size-18" />
                                      </div>
                                      <div className="d-flex">
                                        <div className="flex-shrink-0 me-3">
                                          <h5 className="font-size-14">
                                            <Moment format="D MMM YY">{noteLog.addedDate}</Moment>


                                          </h5>
                                        </div>
                                        <div className="flex-grow-1">
                                          <h5 className="font-size-14"></h5>
                                        </div>
                                      </div>
                                      <div className="exNote">{noteLog.activityRemarks}</div>
                                    </li>
                                  ))}

                                </ul>
                    </div>
                  </TabPane>
                  <TabPane tabId="5">
                    <div className="tabContent">
                    <Formik
              enableReinitialize={true}
              initialValues={{
                actionType: '',
                refId: worksheetLead.leadId,
                addedDate: new Date(),
                remarks:'',
                addedBy:localStorage.getItem('userId'),
                activityParentRefId:worksheetLead.leadId,
                activityParentRefGuid:worksheetLead.campaignProjectGuid
              }}
              validationSchema={Yup.object().shape({
                actionType: Yup.string().required(
                  "Please Select Action"
                ),
                remarks:Yup.string().required(
                  "Enter Note"
                ),
              })}

              onSubmit={values => {
                
                  onAddCallLog(values)
                  //this.toggleAllCanavas();
            }}
            >
              {({ errors, touched, values, handleChange, setFieldValue }) => (
                <Form
                  className="needs-validation"
                >

                  <Row className="mt20 mb20">



                    <Col lg="12">
                      <div role="group" className="btnCheckGroup" aria-labelledby="my-radio-group">
                        <label>
                          <SafeField type="radio" name="actionType" id="actionType1" value="No Answer" 
                          onChange={(e) => {
                            handleChange(e);
                            setFieldValue("remarks", e.target.value);
                          }} />
                          No Answer
                        </label>
                        <label>
                          <SafeField type="radio" name="actionType" id="actionType2" value="Left Voicemail" 
                           onChange={(e) => {
                            handleChange(e);
                            setFieldValue("remarks", e.target.value);
                          }} 
                          />
                          Left Voicemail
                        </label>
                        <label>
                          <SafeField type="radio" name="actionType" id="actionType2" value="Bad Number" 
                           onChange={(e) => {
                            handleChange(e);
                            setFieldValue("remarks", e.target.value);
                          }} 
                          />
                          Bad Number
                        </label>

                      </div>
                      <ErrorMessage
                          name="actionType"
                          component="div"
                          className="invalid-feedback"
                        />  

                    </Col>

                  </Row>
                  <Row>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="addedDate">
                          Log Date
                        </Label>
                        <Flatpickr
                          className={
                            "form-control" +
                            (errors.addedDate && touched.addedDate
                              ? " is-invalid"
                              : "")
                          }
                          placeholder=""
                          value={values.addedDate}
                          onChange={(value) => setFieldValue('addedDate', value[0])}
                          options={{
                            altInput: true,
                            altFormat: "F j, Y",
                            dateFormat: "Y-m-d"
                          }}
                        />
                        <ErrorMessage
                          name="addedDate"
                          component="div"
                          className="invalid-feedback"
                        />

                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="remarks">
                          Add Message
                        </Label>
                        <SafeField
                          name="remarks"
                          
                          as="textarea"
                          
                          className="form-control"
                          value={values.remarks} 
                          onChange={(e) => setFieldValue("remarks", e.target.value)}    
                          id="remarks"

                        />
                         <ErrorMessage
                          name="remarks"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>


                </Form>
              )}
            </Formik>
            <div className="mb-5 h4 card-title mt-20">Call Log History</div>
                                <ul className="verti-timeline list-unstyled">

                                  {map(calllogs, (callLog, callkey) => (

                                    <li className="event-list eventlist" key={"_call_" + callkey}>
                                      <div className="event-timeline-dot">
                                        <i className="bx bx-right-arrow-circle font-size-18" />
                                      </div>
                                      <div className="d-flex">
                                        <div className="flex-shrink-0 me-3">
                                          <h5 className="font-size-14">
                                            <Moment format="D MMM YY">{callLog.addedDate}</Moment>

                                            <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                                          </h5>
                                        </div>
                                        <div className="flex-grow-1">
                                          <h5 className="font-size-14">{localization["ActivitySubType_"+ callLog.activityType+"_"+callLog.activitySubType]}</h5>
                                        </div>
                                      </div>
                                      <div className="exNote">{callLog.activityRemarks}</div>
                                    </li>
                                  ))}

                                </ul>      
                    </div>
                  </TabPane>
                  <TabPane tabId="6">
                    <div className="tabContent">
                    <Formik
              enableReinitialize={true}
              initialValues={{
                actionType: '',
                refId: worksheetLead.leadId,
                addedDate: new Date(),
                remarks:'',
                addedBy:localStorage.getItem('userId'),
                activityParentRefId:worksheetLead.leadId,
                activityParentRefGuid:worksheetLead.campaignProjectGuid 

              }}
              validationSchema={Yup.object().shape({
                actionType: Yup.string().required(
                  "Please Select Action"
                )
              })}

              onSubmit={values => {
                  onAddEmailLog(values)
                  //this.toggleAllCanavas();
            }}
            >
              {({ errors, touched, values, handleChange, setFieldValue }) => (
                <Form
                  className="needs-validation"
                >

                  <Row className="mt20 mb20">



                    <Col lg="12">
                      <div role="group" className="btnCheckGroup" aria-labelledby="my-radio-group">
                        <label>
                          <SafeField type="radio" name="actionType" id="actionType1" value="Email Sent" 
                           onChange={(e) => {
                            handleChange(e);
                            setFieldValue("remarks", e.target.value);
                          }}
                          />
                          Email Sent
                        </label>
                        <label>
                          <SafeField type="radio" name="actionType" id="actionType2" value="Email Received" 
                           onChange={(e) => {
                            handleChange(e);
                            setFieldValue("remarks", e.target.value);
                          }}
                          />
                          Email Received
                        </label>
                        <label>
                          <SafeField type="radio" name="actionType" id="actionType2" value="Email Bounced" 
                           onChange={(e) => {
                            handleChange(e);
                            setFieldValue("remarks", e.target.value);
                          }}
                          />
                          Email Bounced
                        </label>

                      </div>
                      <ErrorMessage
                          name="actionType"
                          component="div"
                          className="invalid-feedback"
                        />
                    </Col>

                  </Row>
                  <Row>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="addedDate">
                          Log Date
                        </Label>
                        <Flatpickr
                          className={
                            "form-control" +
                            (errors.addedDate && touched.addedDate
                              ? " is-invalid"
                              : "")
                          }
                          placeholder=""
                          value={values.addedDate}
                          onChange={(value) => setFieldValue('addedDate', value[0])}
                          options={{
                            altInput: true,
                            altFormat: "F j, Y",
                            dateFormat: "Y-m-d"
                          }}
                        />
                        <ErrorMessage
                          name="addedDate"
                          component="div"
                          className="invalid-feedback"
                        />

                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="remarks">
                          Add Message
                        </Label>
                        <SafeField
                          name="remarks"
                          onChange={handleChange}
                          as="textarea"

                          className="form-control"

                          id="remarks"

                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>


                </Form>
              )}
            </Formik>
            <div className="mb-5 h4 card-title mt-20">Email Log History</div>
                                <ul className="verti-timeline list-unstyled">

                                {map(emaillogs, (emailLog, emailkey) => (

                                  <li className="event-list eventlist" key={"_email_" + emailkey}>
                                    <div className="event-timeline-dot">
                                      <i className="bx bx-right-arrow-circle font-size-18" />
                                    </div>
                                    <div className="d-flex">
                                      <div className="flex-shrink-0 me-3">
                                        <h5 className="font-size-14">
                                          <Moment format="D MMM YY">{emailLog.addedDate}</Moment>

                                          <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                                        </h5>
                                      </div>
                                      <div className="flex-grow-1">
                                        <h5 className="font-size-14">{localization["ActivitySubType_"+ emailLog.activityType+"_"+emailLog.activitySubType]}</h5>
                                      </div>
                                    </div>
                                    <div className="exNote">{emailLog.activityRemarks}</div>
                                  </li>
                                ))}

                                </ul>        
                    </div>
                  </TabPane>
                </TabContent>
              


              </OffcanvasBody>
            </Offcanvas>
            <Offcanvas
              isOpen={this.state.isSubmittedData}
              direction="end"
              toggle={this.toggleSubmittedCanvas}
              style={{ width: 800 }}

            >
              <OffcanvasHeader className="submittedWorksheet" toggle={this.toggleSubmittedCanvas}>
                Submitted Worksheet <span className="float-end"><Link onClick={this.toggleModal}><i className=" bx bx-printer"></i></Link></span>
              </OffcanvasHeader>
              <OffcanvasBody>
                <Nav pills className="navtab-bg nav-justified">
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab1 === "1",
                      })}
                      onClick={() => {
                        this.toggle1("1");
                      }}
                    >
                      Applicant Info
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab1 === "2",
                      })}
                      onClick={() => {
                        this.toggle1("2");
                      }}
                    >
                      Unit Choices
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab1 === "4",
                      })}
                      onClick={() => {
                        this.toggle1("4");
                      }}
                    >
                      Unit Status
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab1 === "3",
                      })}
                      onClick={() => {
                        this.toggle1("3");
                      }}
                    >
                      Documents
                    </NavLink>
                  </NavItem>

                </Nav>
                <TabContent
                  activeTab={this.state.activeTab1}
                  className="p-3 text-muted"
                >
                  <TabPane tabId="1">
                    <div className="tabContent">

                       
                    <Alert color="" role="alert" style={{ fontSize: 15, color: '#000', border: '1px solid #ccc', borderRadius: 12 }}>
                  <Row>
                    <Col>
                      <span>
                        <strong>Submitted date:</strong> <br/>{worksheetLead?.filledDate ? <Moment format="DD MMM YYYY">{worksheetLead?.filledDate}</Moment> : ''}
                      </span>
                    </Col>

                    <Col>
                      <span><strong>Allotment  Status:</strong> <br/> {this.getUnitAllocationStatusId(worksheetLead?.unitStatusId)}</span>
                    </Col>

                    <Col>
                      <span>
                          {worksheetLead.unitStatusId == 0 &&(
                             <>
                            <RsLink className="btn-add" iconClass="fas fa-recycle" onClick={() => this.handleClearProject(worksheetLead)}>Clear Worksheet</RsLink>
                            <br/>
                            <small>(more info)</small>
                            </>   
                          )}
                          
                            
                      </span>
                    </Col>
                  </Row>

                </Alert>
                                              


                      {map(worksheetPurData, (purData, purkey) => (
                        <>
                          <h5>{purkey + 1 === 1 ? "Principal Applicant" : "Secondary Applicant"}</h5>
                          <div className="table-responsive">
                            <Table className="table table-striped">

                              <tbody>
                                <tr>
                                  <th scope="row">Name</th>
                                  <td>{purData.firstName + " " + purData.lastName}</td>

                                </tr>
                                <tr>
                                  <th scope="row">Address</th>
                                  <td>{purData.address}</td>
                                </tr>
                                <tr>
                                  <th scope="row">City</th>
                                  <td>{purData.city}</td>

                                </tr>
                                <tr>
                                  <th scope="row">Province</th>
                                  <td>{purData.province}</td>

                                </tr>
                                <tr>
                                  <th scope="row">Phone</th>
                                  <td>{purData.homePhone}</td>

                                </tr>
                                <tr>
                                  <th scope="row">Cell</th>
                                  <td>{purData.cellPhone}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Email</th>
                                  <td>{purData.email}</td>

                                </tr>
                                <tr>
                                  <th scope="row">Birth Date</th>
                                  <td>{purData.birthDate ? <Moment format="D MMM YY">{purData.birthDate}</Moment> : ''}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Drivers License</th>
                                  <td>{purData.driversLicense}</td>

                                </tr>
                                <tr>
                                  <th scope="row">Occupation</th>
                                  <td>{purData.occupation}</td>
                                </tr>

                              </tbody>
                            </Table>
                          </div>
                          <p>{" "}</p>
                        </>
                      ))}
                    </div>
                  </TabPane>
                  <TabPane tabId="2">
                    <div className="tabContent">
                       <Alert color="" role="alert" style={{ fontSize: 15, color: '#000', border: '1px solid #ccc', borderRadius: 12 }}>
                  <Row>
                    <Col>
                      <span>
                        <strong>Submitted date:</strong> <br/>{worksheetLead?.filledDate ? <Moment format="DD MMM YYYY">{worksheetLead?.filledDate}</Moment> : ''}
                      </span>
                    </Col>

                    <Col>
                      <span><strong>Allotment  Status:</strong> <br/> {this.getUnitAllocationStatusId(worksheetLead?.unitStatusId)}</span>
                    </Col>

                    <Col>
                      <span>
                          {worksheetLead.unitStatusId == 0 ?
                            <RsLink className="btn-add" iconClass="fas fa-recycle" onClick={() => this.handleClearProject(worksheetLead)}>Clear Worksheet</RsLink>
                            : ' '}
                      </span>
                    </Col>
                  </Row>

                </Alert>
                      <div className="table-responsive">
                        <Table className="table table-sm m-0">

                          <tbody>
                            <tr>
                            <th scope="row">Parking</th>
                              <td>  
                                { worksheetLead.isLockerRequired ? 'Yes' : 'No' }
                              </td>
                            </tr>
                            <tr>
                            <th scope="row">Locker</th>
                              <td>  
                                { worksheetLead.isParkingRequired ? 'Yes' : 'No' }
                              </td>
                            </tr>
                            {map(worksheetUnitData, (unitData, unitkey) => (
                              <>
                                <tr>
                                  <th scope="row">Choice {unitkey + 1}</th>
                                  <td>Model: {unitData.optionNumber} {" "} Type: {unitData.optionType}</td>


                                </tr>
                                <tr>
                                  <td colSpan="2">Notes: {unitData.optionNotes}</td>
                                </tr>
                              </>
                            ))}


                          </tbody>
                        </Table>
                      </div>
                    </div>
                  </TabPane>

                  <TabPane tabId="3">
                    <div className="tabContent">
                           <Alert color="" role="alert" style={{ fontSize: 15, color: '#000', border: '1px solid #ccc', borderRadius: 12 }}>
                  <Row>
                    <Col>
                      <span>
                        <strong>Submitted date:</strong> <br/>{worksheetLead?.filledDate ? <Moment format="DD MMM YYYY">{worksheetLead?.filledDate}</Moment> : ''}
                      </span>
                    </Col>

                    <Col>
                      <span><strong>Allotment  Status:</strong> <br/> {this.getUnitAllocationStatusId(worksheetLead?.unitStatusId)}</span>
                    </Col>

                    <Col>
                      <span>
                          {worksheetLead.unitStatusId == 0 ?
                            <RsLink className="btn-add" iconClass="fas fa-recycle" onClick={() => this.handleClearProject(worksheetLead)}>Clear Worksheet</RsLink>
                            : ' '}
                      </span>
                    </Col>
                  </Row>

                </Alert>
                      <div className="table-responsive">


                        <h5>Purchaser</h5>
                        <Table className="table table-sm m-0">

                          <tbody>
                            {map(worksheetDocData, (docData, dockey) => (
                              <tr>
                                <th scope="row">{dockey + 1 === 1 ? "Principal Applicant" : "Secondary Applicant"}</th>
                                <td>{docData.documentTitle}</td>
                                <td><a target="_blank" rel="noreferrer" href={docData.documentURL}>View</a></td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                        <p>{" "}</p>



                      </div>
                    </div>
                  </TabPane>
                  <TabPane tabId="4">
                   
                      <div className="tabContent">
                             <Alert color="" role="alert" style={{ fontSize: 15, color: '#000', border: '1px solid #ccc', borderRadius: 12 }}>
                  <Row>
                    <Col>
                      <span>
                        <strong>Submitted date:</strong> <br/>{worksheetLead?.filledDate ? <Moment format="DD MMM YYYY">{worksheetLead?.filledDate}</Moment> : ''}
                      </span>
                    </Col>

                    <Col>
                      <span><strong>Allotment  Status:</strong> <br/> {this.getUnitAllocationStatusId(worksheetLead?.unitStatusId)}</span>
                    </Col>

                    <Col>
                      <span>
                          {worksheetLead.unitStatusId == 0 ?
                            <RsLink className="btn-add" iconClass="fas fa-recycle" onClick={() => this.handleClearProject(worksheetLead)}>Clear Worksheet</RsLink>
                            : ' '}
                      </span>
                    </Col>
                  </Row>

                </Alert>
                        <Formik
                          enableReinitialize={true}
                          initialValues={{
                            updateViaEmail: unitdata?.updateViaEmail ? true : false,
                            depositPaymentReceived:unitdata?.depositPaymentReceived ? true : false,
                            paymentInfo:unitdata?.paymentInfo ? unitdata.paymentInfo : '',
                            emailContent:unitdata?.emailContent ? unitdata.emailContent : '',
                            id: worksheetLead.id,
                            projectLeadWorkSheetId: worksheetLead.id,
                            unitStatusId: (unitdata?.unitStatusId) ? unitdata.unitStatusId : 1,
                            unitStatusText: (unitdata?.unitStatusText) ? unitdata.unitStatusText : 'Waiting for allocations',
                            unitNote: (unitdata?.unitNote) ? unitdata.unitNote : '',
                            allocationBy: parseInt(localStorage.getItem('userId')),
                            createProjectLeadWorkSheetAllocationList: worksheetUnitData?.map((item) => ({
                              projectLeadWorkSheetId: worksheetLead.id,
                              selectedOptionId: item?.isAllocated ? item?.id : null,
                              selectedOptionText: item?.optionNumber
                                ? `${item.optionNumber}/${item.optionType}`
                                : "",
                              unitCost: item?.unitCost || "", 
                              insideSqFt: item?.insideSqFt || "", 
                              outsideSqFt: item?.outsideSqFt || "", 
                            })) ||  []
                            
                          }}
                         validationSchema={Yup.object().shape({
                          unitStatusId: Yup.number().required(),
                          createProjectLeadWorkSheetAllocationList: Yup.array()
                            .of(
                              Yup.object().shape({
                                selectedOptionId: Yup.string().nullable(),
                                insideSqFt: Yup.number()
                                  .typeError("Must be a number")
                                  .when("selectedOptionId", {
                                    is: (val) => !!val,
                                    then: Yup.number().notRequired("Inside sq. ft. is required"),
                                    otherwise: Yup.number().notRequired(),
                                  }),
                                outsideSqFt: Yup.number()
                                  .typeError("Must be a number")
                                  .when("selectedOptionId", {
                                    is: (val) => !!val,
                                    then: Yup.number().notRequired("Outside sq. ft. is required"),
                                    otherwise: Yup.number().notRequired(),
                                  }),
                                unitCost: Yup.number()
                                  .typeError("Must be a number")
                                  .when("selectedOptionId", {
                                    is: (val) => !!val,
                                    then: Yup.number().required("Cost is required"),
                                    otherwise: Yup.number().notRequired(),
                                  }),
                              })
                            )
                            .when("unitStatusId", {
                              is: 3,
                              then: (schema) =>
                                schema.test(
                                  "at-least-one-selectedOptionId",
                                  "At least one option must be selected when Unit Status is 3",
                                  (value) => Array.isArray(value) && value.some((item) => !!item.selectedOptionId)
                                ),
                            }),
                        })}

                          onSubmit={(values) => {
                            const filteredList = this.removeEmptySheetAllocationList(values.createProjectLeadWorkSheetAllocationList);
                            const convertedList = filteredList.map(item => ({
                              ...item,
                              unitCost: parseInt(item.unitCost, 10) || 0,
                              insideSqFt: parseInt(item.insideSqFt, 10) || 0,
                              outsideSqFt: parseInt(item.outsideSqFt, 10) || 0,
                            }));

                            const allocationData = {
                              ...values,
                              createProjectLeadWorkSheetAllocationList: convertedList,
                            };
                            const obj = JSON.parse(localStorage.getItem("authUser"));
                            const token = obj.resultData.bearerToken;
                            const str = 'Bearer ' + token;
                            const headers = {
                              'Content-Type': 'application/json',
                              'Authorization': str
                            };

                            toast.loading("Please wait...");
                            axios.post(`${API_URL}ProjectLeadWorkSheet/AddProjectLeadWorkSheetAllocation`, allocationData, { headers })
                              .then(response => {
                                toast.dismiss();
                                if (response.data.success) {
                                  toast.success("Saved successfully");
                                  onGetProjectWorksheetLead(this.props.match.params.projectId, 0);
                                  this.toggleSubmit();
                                } else {
                                  toast.warn(response.validationErrors[0]);
                                }
                              })
                              .catch(error => {
                                toast.dismiss();
                                console.error('Error:', error);
                              });
                          }}
                        >
                          {({ errors, touched, values, handleChange, handleBlur, setFieldValue }) => (
                            <Form
                              className="needs-validation"
                            >
                              <Row>

                                <Col md="12">
                                  <FormGroup className="mb-3">


                                    <Input
                                      type="radio"
                                      id="customRadioInline1"
                                      name="unitStatusId"
                                      className="form-check-input mt-2"
                                      value="1"
                                      checked={values.unitStatusId === 1}
                                      onChange={(e) => {
                                        setFieldValue('unitStatusId', 1);
                                        setFieldValue('unitStatusText', 'Waiting for allocation');
                                      }}
                                    />
                                    <Label
                                      className="form-check-label ms-4"
                                      htmlFor="customRadioInline1"
                                    >
                                      <span className="">Waiting for allocation</span>
                                    </Label>
                                  </FormGroup>
                                </Col>
                                <Col md="12">
                                  <FormGroup className="mb-3">


                                    <Input
                                      type="radio"
                                      id="customRadioInline2"
                                      name="unitStatusId"
                                      className="form-check-input mt-2"
                                      value="2"
                                      checked={values.unitStatusId === 2}
                                      onChange={(e) => {
                                        setFieldValue('unitStatusId', 2);
                                        setFieldValue('unitStatusText', 'Unit Not allocated');
                                      }}
                                    />
                                    <Label
                                      className="form-check-label ms-4"
                                      htmlFor="customRadioInline2"
                                    >
                                      <span className="">Unit Not allocated</span>
                                    </Label>
                                  </FormGroup>
                                </Col>
                                <Col md="12">
                                  <FormGroup className="mb-3">


                                    <Input
                                      type="radio"
                                      id="customRadioInline3"
                                      name="unitStatusId"
                                      className="form-check-input mt-2"
                                      value="3"
                                      checked={values.unitStatusId === 3}
                                      onChange={(e) => {
                                        setFieldValue('unitStatusId', 3);
                                        setFieldValue('unitStatusText', 'Unit Allocated');
                                      }}
                                    />
                                    <Label
                                      className="form-check-label ms-4"
                                      htmlFor="customRadioInline3"
                                    >
                                      <span className="">Unit Allocated</span>
                                    </Label>
                                  </FormGroup>
                                </Col>
                                 {values.unitStatusId !== 3 && (
                                <Col md="12">
                                  <FormGroup className="mb-3">


                                    <Input
                                      type="radio"
                                      id="customRadioInline4"
                                      name="unitStatusId"
                                      className="form-check-input mt-2"
                                      value="4"
                                      checked={values.unitStatusId === 4}
                                      onChange={(e) => {
                                        setFieldValue('unitStatusId', 4);
                                        setFieldValue('unitStatusText', 'Withdrawn from client');
                                      }}
                                    />
                                    <Label
                                      className="form-check-label ms-4"
                                      htmlFor="customRadioInline4"
                                    >
                                      Withdrawn from client
                                    </Label>
                                  </FormGroup>
                                </Col>
                                 )}
                              </Row>
                              {values.unitStatusId !== 1 && (
                                <>
                                  <hr></hr>
                                  {values.unitStatusId !== 2 && values.unitStatusId !== 4 && (
                                    <>
                                      <div id="Selchoice">
                                        <FieldArray name="createProjectLeadWorkSheetAllocationList">
                                          {({ insert, remove, push }) => (
                                            <>
                                               {map(worksheetUnitData, (unitData, unitkey) => {
        const isDisabled = worksheetLead?.unitStatusId === 3; 

        return (
                                                <Row key={unitkey}>
                                                  <Col md="12">
                                                    <div className="form-check mb-3">
                                                      <Field
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        name={`createProjectLeadWorkSheetAllocationList.${unitkey}.selectedOptionId`}
                                                        //value={unitData.id}
                                                        id={`createProjectLeadWorkSheetAllocationList.${unitkey}.selectedOptionId`}
                                                        disabled={isDisabled}
                                                        onChange={(e) => {
                                                          if (isDisabled) return;
                                                          const isChecked = e.target.checked;
                                                          const newValue = isChecked ? unitData.id : null;
                                                          const optionText = isChecked ? `${unitData.optionNumber}/${unitData.optionType}` : '';

                                                          setFieldValue(`createProjectLeadWorkSheetAllocationList.${unitkey}.selectedOptionId`, newValue);
                                                          setFieldValue(`createProjectLeadWorkSheetAllocationList.${unitkey}.selectedOptionText`, optionText);
                                                        }}
                                                      />
                                                      <label
                                                        className="form-check-label"
                                                        id={`createProjectLeadWorkSheetAllocationList.${unitkey}.selectedOptionId`}
                                                      >
                                                        {unitData.optionNumber}/{unitData.optionType}
                                                      </label>
                                                    </div>

                                                  </Col>
                                                  <Col md="4">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor={`createProjectLeadWorkSheetAllocationList.${unitkey}.insideSqFt`}>
                                                        {this.props.t("Inside sq. ft.")}
                                                      </Label>
                                                      <SafeField
                                                        name={`createProjectLeadWorkSheetAllocationList.${unitkey}.insideSqFt`}
                                                        type="text"
                                                        disabled={isDisabled}
                                                        className={`form-control${errors.createProjectLeadWorkSheetAllocationList &&
                                                            errors.createProjectLeadWorkSheetAllocationList[unitkey] &&
                                                            errors.createProjectLeadWorkSheetAllocationList[unitkey].insideSqFt &&
                                                            touched.createProjectLeadWorkSheetAllocationList &&
                                                            touched.createProjectLeadWorkSheetAllocationList[unitkey] &&
                                                            touched.createProjectLeadWorkSheetAllocationList[unitkey].insideSqFt
                                                            ? " is-invalid"
                                                            : ""
                                                          }`}
                                                      />
                                                      <ErrorMessage
                                                        name={`createProjectLeadWorkSheetAllocationList.${unitkey}.insideSqFt`}
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                                                  <Col md="4">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor={`createProjectLeadWorkSheetAllocationList.${unitkey}.outsideSqFt`}>
                                                        {this.props.t("Outside sq.ft")}
                                                      </Label>
                                                      <SafeField
                                                        name={`createProjectLeadWorkSheetAllocationList.${unitkey}.outsideSqFt`}
                                                        type="text"
                                                        disabled={isDisabled}
                                                        onChange={handleChange}
                                                        className={`form-control${errors.createProjectLeadWorkSheetAllocationList &&
                                                            errors.createProjectLeadWorkSheetAllocationList[unitkey] &&
                                                            errors.createProjectLeadWorkSheetAllocationList[unitkey].outsideSqFt &&
                                                            touched.createProjectLeadWorkSheetAllocationList &&
                                                            touched.createProjectLeadWorkSheetAllocationList[unitkey] &&
                                                            touched.createProjectLeadWorkSheetAllocationList[unitkey].outsideSqFt
                                                            ? " is-invalid"
                                                            : ""
                                                          }`}
                                                      />
                                                      <ErrorMessage
                                                        name={`createProjectLeadWorkSheetAllocationList.${unitkey}.outsideSqFt`}
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                                                  <Col md="4">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor={`createProjectLeadWorkSheetAllocationList.${unitkey}.unitCost`}>
                                                       Cost ({projectData.projectCurrencyCode}) *
                                                      </Label>
                                                       <CurrencyInput
                                                      name={`createProjectLeadWorkSheetAllocationList.${unitkey}.unitCost`}
                                                      disabled={isDisabled}
                                                      value={values.createProjectLeadWorkSheetAllocationList?.[unitkey]?.unitCost}
                                                      className={`form-control${errors.createProjectLeadWorkSheetAllocationList &&
                                                            errors.createProjectLeadWorkSheetAllocationList[unitkey] &&
                                                            errors.createProjectLeadWorkSheetAllocationList[unitkey].unitCost &&
                                                            touched.createProjectLeadWorkSheetAllocationList &&
                                                            touched.createProjectLeadWorkSheetAllocationList[unitkey] &&
                                                            touched.createProjectLeadWorkSheetAllocationList[unitkey].unitCost
                                                            ? " is-invalid"
                                                            : ""
                                                          }`}
                                                      onValueChange={(value) => setFieldValue(`createProjectLeadWorkSheetAllocationList.${unitkey}.unitCost`, value)}
                                                      prefix={projectData?.projectCurrencyCode}
                                                      decimalsLimit={2}
                      
                      
                                                    />
                                                     
                                                      <ErrorMessage
                                                        name={`createProjectLeadWorkSheetAllocationList.${unitkey}.unitCost`}
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                                                </Row>
        )

                                              })}
                                            </>
                                          )}
                                        </FieldArray>
                                      </div>
                                      <Row>
                                        <Col sm="12">
                                          <div className="form-check mb-3">
                                            <Field
                                              className="form-check-input"
                                              type="checkbox"
                                              name="depositPaymentReceived"
                                              id="depositPaymentReceived"
                                            />
                                            {" "} <label htmlFor="depositPaymentReceived" className="form-check-label">Deposit payment received</label>
                                          </div>
                                        </Col>
                                        {values.depositPaymentReceived && (
                                          <Col md="12">
                                            <FormGroup className="mb-3">
                                              <Label htmlFor="paymentInfo">
                                                {this.props.t("Payment info")}
                                              </Label>
                                              <SafeField
                                                name="paymentInfo"
                                                onChange={handleChange}
                                                as="textarea"
                                                className={
                                                  "form-control" +
                                                  (errors.paymentInfo && touched.paymentInfo
                                                    ? " is-invalid"
                                                    : "")
                                                }
                                                id="paymentInfo"
                                              />
                                              <ErrorMessage
                                                name="paymentInfo"
                                                component="div"
                                                className="invalid-feedback"
                                              />
                                            </FormGroup>
                                          </Col>
                                        )}
                                      </Row>
                                    </>
                                  )}
                                  <Row>
                                    <Col sm="12">
                                      <div className="form-check mb-3">
                                        <Field
                                          className="form-check-input"
                                          type="checkbox"
                                          name="updateViaEmail"
                                          id="updateViaEmail"
                                        />
                                        {" "} <label htmlFor="updateViaEmail" className="form-check-label">Update client via email</label>
                                      </div>
                                    </Col>
                                    {values.updateViaEmail && (
                                      <Col md="12">
                                         <EmailContentEditor
                                          name="emailContent"
                                          setFieldValue={setFieldValue}
                                          initialContent={values.emailContent}
                                          placeholder=""
                                        />
                                       
                                      </Col>
                                    )}
                                  </Row>
                                  <Row id="noteRow">
                                    <Col md="12">
                                      <FormGroup className="mb-3">
                                        <Label htmlFor="unitNote">
                                          {this.props.t("Add Note")}
                                        </Label>
                                        <SafeField
                                          name="unitNote"
                                          onChange={handleChange}
                                          as="textarea"
                                          className={
                                            "form-control" +
                                            (errors.unitNote && touched.unitNote
                                              ? " is-invalid"
                                              : "")
                                          }
                                          id="unitNote"
                                        />
                                        <ErrorMessage
                                          name="unitNote"
                                          component="div"
                                          className="invalid-feedback"
                                        />
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                </>
                              )}
                              <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button> {" "}
                              
                                  {/* {worksheetLead.unitStatusId == 0 ?
                 <RsLink className="btn-add" iconClass="fas fa-recycle" onClick={() => this.handleClearProject(worksheetLead)}>Clear Worksheet</RsLink>
                  : ' '} */}
                              </div>


                             
                            </Form>
                          )}
                        </Formik>


                      </div>
                   
                  </TabPane>
                </TabContent>
             


              </OffcanvasBody>
            </Offcanvas>


            <Offcanvas
              isOpen={this.state.isManualData}
              direction="end"
              toggle={this.toggleManualCanvas}

            >
              <OffcanvasHeader toggle={this.toggleManualCanvas}>
                Manual Upload
              </OffcanvasHeader>
              <OffcanvasBody>
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    projectLeadWorkSheetId: worksheetLead.projectLeadWorkSheetId,
                    projectCampaignLeadId: worksheetLead.projectCampaignLeadId,
                    campaignProjectId: parseInt(this.props.match.params.id),
                    noOfOptions: 0,
                    isActive: true,
                    worksheetNotes: '',
                    agentId: parseInt(localStorage.getItem('userId')),
                    isParkingRequired: false,
                    isLockerRequired: false,
                    createProjectLeadWorkSheetOptionList: Array.from({ length: 2 }, () => ({ projectLeadWorkSheetId: 0, optionNumber: '', optionType: '', optionNotes: '', agentId: parseInt(localStorage.getItem('userId')), addedBy: '', })),

                    createProjectLeadWorkSheetPurchaserList: Array.from({ length: 2 }, () => ({
                      projectLeadWorkSheetId: 0,
                      firstName: '',
                      lastName: '',
                      address: '',
                      city: '',
                      province: '',
                      postalCode: '',
                      homePhone: '',
                      cellPhone: '',
                      //email: '',
                      //birthDate: new Date(),
                      driversLicense: '',
                      occupation: '',
                      createProjectLeadWorkSheetPurchaserDocumentList: [{ projectLeadWorkSheetId: 0, projectLeadWorkSheetPurchaserId: 0, projectProspectAgentDocumentId: 0, documentTitle: '' }]
                    })),
                  }}
                  validationSchema={Yup.object().shape({
                    createProjectLeadWorkSheetOptionList: Yup.array().of(
                      Yup.object().shape({
                        optionNumber: Yup.string().required('Model Name is required'),
                        optionType: Yup.string().required('Bedroom Type is required'),
                        optionNotes: Yup.string().required('Bedroom Type is required')
                      })
                    ),
                    createProjectLeadWorkSheetPurchaserList: Yup.array().of(
                      Yup.object().shape({
                        firstName: Yup.string().test('is-required', 'This is required', function (value) {
                          return this.options.index !== 0 || (value && value.trim().length > 0);
                        }),
                        lastName: Yup.string().test('is-required', 'This is required', function (value) {
                          return this.options.index !== 0 || (value && value.trim().length > 0);
                        }),
                        address: Yup.string().test('is-required', 'This is required', function (value) {
                          return this.options.index !== 0 || (value && value.trim().length > 0);
                        }),
                        city: Yup.string().test('is-required', 'This is required', function (value) {
                          return this.options.index !== 0 || (value && value.trim().length > 0);
                        }),
                        province: Yup.string().test('is-required', 'This is required', function (value) {
                          return this.options.index !== 0 || (value && value.trim().length > 0);
                        }),
                        postalCode: Yup.string().test('is-required', 'This is required', function (value) {
                          return this.options.index !== 0 || (value && value.trim().length > 0);
                        }),
                        homePhone: Yup.string().test('is-required', 'This is required', function (value) {
                          return this.options.index !== 0 || (value && value.trim().length > 0);
                        }),
                        cellPhone: Yup.string().test('is-required', 'This is required', function (value) {
                          return this.options.index !== 0 || (value && value.trim().length > 0);
                        }),
                        birthDate: Yup.string().test('is-required', 'This is required', function (value) {
                          return this.options.index !== 0 || (value && value.trim().length > 0);
                        }),
                        driversLicense: Yup.string().test('is-required', 'This is required', function (value) {
                          return this.options.index !== 0 || (value && value.trim().length > 0);
                        }),
                        occupation: Yup.string().test('is-required', 'This is required', function (value) {
                          return this.options.index !== 0 || (value && value.trim().length > 0);
                        })
                      })
                    )
                  })}
                  onSubmit={this.handleSubmit}
                >
                  {({
                    errors,
                    touched,
                    values,
                    handleChange,
                    setFieldValue,
                  }) => (
                    <Form className="needs-validation">

                      <FieldArray name="createProjectLeadWorkSheetOptionList">
                        {({ insert, remove, push }) => (
                          <>
                            {values.createProjectLeadWorkSheetOptionList.map((LeadWorkSheetOptionList, index) => (
                              <Row key={index}>
                                <h4>Choice {index + 1}</h4>
                                <Col sm="4">
                                  <FormGroup className="mb-3">
                                    <Label htmlFor={`createProjectLeadWorkSheetOptionList.${index}.optionNumber`}>
                                      {this.props.t("Model Name")}
                                    </Label>
                                    <SafeField
                                      name={`createProjectLeadWorkSheetOptionList.${index}.optionNumber`}
                                      type="text"
                                      className={
                                        'form-control' +
                                        (errors.createProjectLeadWorkSheetOptionList?.[index]?.optionNumber && touched.createProjectLeadWorkSheetOptionList?.[index]?.optionNumber
                                          ? ' is-invalid'
                                          : '')
                                      }
                                      placeholder=""
                                      id={`optionNumber${index + 1}`}
                                    />
                                    <ErrorMessage
                                      name={`createProjectLeadWorkSheetOptionList.${index}.optionNumber`}
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </FormGroup>
                                </Col>
                                <Col sm="4">
                                  <FormGroup className="mb-3">
                                    <Label htmlFor={`createProjectLeadWorkSheetOptionList.${index}.optionType`}>
                                      {this.props.t("Bedroom Type")}
                                    </Label>
                                    <SafeField
                                      name={`createProjectLeadWorkSheetOptionList.${index}.optionType`}
                                      type="text"
                                      className={
                                        'form-control' +
                                        (errors.createProjectLeadWorkSheetOptionList?.[index]?.optionType && touched.createProjectLeadWorkSheetOptionList?.[index]?.optionType ? ' is-invalid' : '')
                                      }
                                      placeholder=""
                                      id={`optionType${index + 1}`}
                                    />
                                    <ErrorMessage name={`createProjectLeadWorkSheetOptionList.${index}.optionType`} component="div" className="invalid-feedback" />
                                  </FormGroup>
                                </Col>
                                <Col sm="4">
                                  <FormGroup className="mb-3">
                                    <Label htmlFor={`createProjectLeadWorkSheetOptionList.${index}.optionNotes`}>
                                      {this.props.t("Notes")}
                                    </Label>
                                    <SafeField
                                      name={`createProjectLeadWorkSheetOptionList.${index}.optionNotes`}
                                      type="text"
                                      className={
                                        'form-control' +
                                        (errors.createProjectLeadWorkSheetOptionList?.[index]?.optionNotes && touched.createProjectLeadWorkSheetOptionList?.[index]?.optionNotes ? ' is-invalid' : '')
                                      }
                                      placeholder=""
                                      id={`optionNotes${index + 1}`}
                                    />
                                    <ErrorMessage name={`createProjectLeadWorkSheetOptionList.${index}.optionNotes`} component="div" className="invalid-feedback" />
                                  </FormGroup>
                                </Col>
                              </Row>
                            ))}
                          </>
                        )}
                      </FieldArray>

                      <Row>
                        <Col sm="12">
                          <hr />
                        </Col>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label className="form-check-label me-4" htmlFor="isParkingRequired">
                              <span className="h4">Parking</span>
                            </Label>
                            <SafeField
                              type="checkbox"
                              id="isParkingRequired"
                              name="isParkingRequired"
                              className="form-check-input mt-2"
                            />
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label className="form-check-label me-4" htmlFor="isLockerRequired">
                              <span className="h4">Locker</span>
                            </Label>
                            <SafeField
                              type="checkbox"
                              id="isLockerRequired"
                              name="isLockerRequired"
                              className="form-check-input mt-2"
                            />
                          </FormGroup>
                        </Col>
                        <Col sm="12">
                          <hr />
                        </Col>
                      </Row>
                      <Row>
                        <div className="accordion" id="accordion">
                          <FieldArray name="createProjectLeadWorkSheetPurchaserList">
                            {({ insert, remove, push }) => (
                              <>
                                {values.createProjectLeadWorkSheetPurchaserList.map((purchaser, index) => (
                                  <div className="accordion-item" key={index}>
                                    <h2 className="accordion-header" id={`heading${index}`}>
                                      <button
                                        className="accordion-button fw-medium"
                                        type="button"
                                        onClick={() => this.toggleAccordion(index)}
                                        style={{ cursor: 'pointer' }}
                                      >
                                        Purchaser {index + 1}
                                      </button>
                                    </h2>

                                    <Collapse isOpen={this.state.accordionState[`col${index}`]} className="accordion-collapse">
                                      <div className="accordion-body">
                                        <Row>
                                          <Col sm="6">
                                            <FormGroup className="mb-3">
                                              <Label htmlFor={`createProjectLeadWorkSheetPurchaserList.${index}.firstName`}>
                                                {this.props.t("First Name")}
                                              </Label>
                                              <SafeField
                                                name={`createProjectLeadWorkSheetPurchaserList.${index}.firstName`}
                                                type="text"
                                                className={
                                                  'form-control' +
                                                  (errors.createProjectLeadWorkSheetPurchaserList?.[index]?.firstName && touched.createProjectLeadWorkSheetPurchaserList?.[index]?.firstName
                                                    ? ' is-invalid'
                                                    : '')
                                                }
                                                placeholder=""
                                              />
                                              <ErrorMessage
                                                name={`createProjectLeadWorkSheetPurchaserList.${index}.firstName`}
                                                component="div"
                                                className="invalid-feedback"
                                              />
                                            </FormGroup>
                                          </Col>
                                          <Col sm="6">
                                            <FormGroup className="mb-3">
                                              <Label htmlFor={`createProjectLeadWorkSheetPurchaserList.${index}.lastName`}>
                                                {this.props.t("Last Name")}
                                              </Label>
                                              <SafeField
                                                name={`createProjectLeadWorkSheetPurchaserList.${index}.lastName`}
                                                type="text"
                                                className={
                                                  'form-control' +
                                                  (errors.createProjectLeadWorkSheetPurchaserList?.[index]?.lastName && touched.createProjectLeadWorkSheetPurchaserList?.[index]?.lastName
                                                    ? ' is-invalid'
                                                    : '')
                                                }
                                                placeholder=""
                                              />
                                              <ErrorMessage
                                                name={`createProjectLeadWorkSheetPurchaserList.${index}.lastName`}
                                                component="div"
                                                className="invalid-feedback"
                                              />
                                            </FormGroup>
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col sm="6">
                                            <FormGroup className="mb-3">
                                              <Label htmlFor={`createProjectLeadWorkSheetPurchaserList.${index}.address`}>
                                                {this.props.t("Address")}
                                              </Label>
                                              <SafeField
                                                name={`createProjectLeadWorkSheetPurchaserList.${index}.address`}
                                                type="text"
                                                className={
                                                  'form-control' +
                                                  (errors.createProjectLeadWorkSheetPurchaserList?.[index]?.address && touched.createProjectLeadWorkSheetPurchaserList?.[index]?.address
                                                    ? ' is-invalid'
                                                    : '')
                                                }
                                                placeholder=""
                                              />
                                              <ErrorMessage
                                                name={`createProjectLeadWorkSheetPurchaserList.${index}.address`}
                                                component="div"
                                                className="invalid-feedback"
                                              />
                                            </FormGroup>
                                          </Col>
                                          <Col sm="6">
                                            <FormGroup className="mb-3">
                                              <Label htmlFor={`createProjectLeadWorkSheetPurchaserList.${index}.city`}>
                                                {this.props.t("City")}
                                              </Label>
                                              <SafeField
                                                name={`createProjectLeadWorkSheetPurchaserList.${index}.city`}
                                                type="text"
                                                className={
                                                  'form-control' +
                                                  (errors.createProjectLeadWorkSheetPurchaserList?.[index]?.city && touched.createProjectLeadWorkSheetPurchaserList?.[index]?.city
                                                    ? ' is-invalid'
                                                    : '')
                                                }
                                                placeholder=""
                                              />
                                              <ErrorMessage
                                                name={`createProjectLeadWorkSheetPurchaserList.${index}.city`}
                                                component="div"
                                                className="invalid-feedback"
                                              />
                                            </FormGroup>
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col sm="6">
                                            <FormGroup className="mb-3">
                                              <Label htmlFor={`createProjectLeadWorkSheetPurchaserList.${index}.province`}>
                                                {this.props.t("Province")}
                                              </Label>
                                              <SafeField
                                                name={`createProjectLeadWorkSheetPurchaserList.${index}.province`}
                                                type="text"
                                                className={
                                                  'form-control' +
                                                  (errors.createProjectLeadWorkSheetPurchaserList?.[index]?.province && touched.createProjectLeadWorkSheetPurchaserList?.[index]?.province
                                                    ? ' is-invalid'
                                                    : '')
                                                }
                                                placeholder=""
                                              />
                                              <ErrorMessage
                                                name={`createProjectLeadWorkSheetPurchaserList.${index}.province`}
                                                component="div"
                                                className="invalid-feedback"
                                              />
                                            </FormGroup>
                                          </Col>
                                          <Col sm="6">
                                            <FormGroup className="mb-3">
                                              <Label htmlFor={`createProjectLeadWorkSheetPurchaserList.${index}.postalCode`}>
                                                {this.props.t("Postal Code")}
                                              </Label>
                                              <SafeField
                                                name={`createProjectLeadWorkSheetPurchaserList.${index}.postalCode`}
                                                type="text"
                                                className={
                                                  'form-control' +
                                                  (errors.createProjectLeadWorkSheetPurchaserList?.[index]?.postalCode && touched.createProjectLeadWorkSheetPurchaserList?.[index]?.postalCode
                                                    ? ' is-invalid'
                                                    : '')
                                                }
                                                placeholder=""
                                              />
                                              <ErrorMessage
                                                name={`createProjectLeadWorkSheetPurchaserList.${index}.postalCode`}
                                                component="div"
                                                className="invalid-feedback"
                                              />
                                            </FormGroup>
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col sm="6">
                                            <FormGroup className="mb-3">
                                              <Label htmlFor={`createProjectLeadWorkSheetPurchaserList.${index}.honePhone`}>
                                                {this.props.t("Home Phone")}
                                              </Label>
                                              <SafeField
                                                name={`createProjectLeadWorkSheetPurchaserList.${index}.homePhone`}
                                                type="text"
                                                className={
                                                  'form-control' +
                                                  (errors.createProjectLeadWorkSheetPurchaserList?.[index]?.homePhone && touched.createProjectLeadWorkSheetPurchaserList?.[index]?.homePhone
                                                    ? ' is-invalid'
                                                    : '')
                                                }
                                                placeholder=""
                                              />
                                              <ErrorMessage
                                                name={`createProjectLeadWorkSheetPurchaserList.${index}.homePhone`}
                                                component="div"
                                                className="invalid-feedback"
                                              />
                                            </FormGroup>
                                          </Col>
                                          <Col sm="6">
                                            <FormGroup className="mb-3">
                                              <Label htmlFor={`createProjectLeadWorkSheetPurchaserList.${index}.cellPhone`}>
                                                {this.props.t("Cell Phone")}
                                              </Label>
                                              <SafeField
                                                name={`createProjectLeadWorkSheetPurchaserList.${index}.cellPhone`}
                                                type="text"
                                                className={
                                                  'form-control' +
                                                  (errors.createProjectLeadWorkSheetPurchaserList?.[index]?.cellPhone && touched.createProjectLeadWorkSheetPurchaserList?.[index]?.cellPhone
                                                    ? ' is-invalid'
                                                    : '')
                                                }
                                                placeholder=""
                                              />
                                              <ErrorMessage
                                                name={`createProjectLeadWorkSheetPurchaserList.${index}.cellPhone`}
                                                component="div"
                                                className="invalid-feedback"
                                              />
                                            </FormGroup>
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col sm="6">
                                            <FormGroup className="mb-3">

                                              <Label htmlFor={`createProjectLeadWorkSheetPurchaserList.${index}.email`}>
                                                {this.props.t("Email")}
                                              </Label>
                                              <SafeField
                                                name={`createProjectLeadWorkSheetPurchaserList.${index}.email`}
                                                type="text"
                                                className={
                                                  'form-control' +
                                                  (errors.createProjectLeadWorkSheetPurchaserList?.[index]?.email && touched.createProjectLeadWorkSheetPurchaserList?.[index]?.email
                                                    ? ' is-invalid'
                                                    : '')
                                                }
                                                placeholder=""
                                              />
                                              <ErrorMessage
                                                name={`purchasers.${index}.email`}
                                                component="div"
                                                className="invalid-feedback"
                                              />
                                            </FormGroup>
                                          </Col>
                                          <Col sm="6">
                                            <FormGroup className="mb-3">
                                              <Label htmlFor={`createProjectLeadWorkSheetPurchaserList.${index}.birthDate`}>
                                                {this.props.t("Birth Date")}
                                              </Label>
                                              <Flatpickr
                                                className={`form-control${errors.createProjectLeadWorkSheetPurchaserList?.[index]?.birthDate &&
                                                    touched.createProjectLeadWorkSheetPurchaserList?.[index]?.birthDate
                                                    ? ' is-invalid'
                                                    : ''
                                                  }`}
                                                placeholder=""

                                                onChange={(value) =>
                                                  setFieldValue(`createProjectLeadWorkSheetPurchaserList.${index}.birthDate`, value[0])
                                                }
                                                options={{
                                                  altInput: false,
                                                  altFormat: "F j, Y",
                                                  dateFormat: "Y-m-d"
                                                }}
                                              />

                                              <ErrorMessage
                                                name={`createProjectLeadWorkSheetPurchaserList.${index}.birthDate`}
                                                component="div"
                                                className="invalid-feedback"
                                              />
                                            </FormGroup>
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col sm="6">
                                            <FormGroup className="mb-3">
                                              <Label htmlFor={`createProjectLeadWorkSheetPurchaserList.${index}.driversLicense`}>
                                                {this.props.t("Drivers License")}
                                              </Label>
                                              <SafeField
                                                name={`createProjectLeadWorkSheetPurchaserList.${index}.driversLicense`}
                                                type="text"
                                                className={
                                                  'form-control' +
                                                  (errors.createProjectLeadWorkSheetPurchaserList?.[index]?.driversLicense && touched.createProjectLeadWorkSheetPurchaserList?.[index]?.driversLicense
                                                    ? ' is-invalid'
                                                    : '')
                                                }
                                                placeholder=""
                                              />
                                              <ErrorMessage
                                                name={`createProjectLeadWorkSheetPurchaserList.${index}.driversLicense`}
                                                component="div"
                                                className="invalid-feedback"
                                              />
                                            </FormGroup>
                                          </Col>
                                          <Col sm="6">
                                            <FormGroup className="mb-3">
                                              <Label htmlFor={`createProjectLeadWorkSheetPurchaserList.${index}.occupation`}>
                                                {this.props.t("Occupation")}
                                              </Label>
                                              <SafeField
                                                name={`createProjectLeadWorkSheetPurchaserList.${index}.occupation`}
                                                type="text"
                                                className={
                                                  'form-control' +
                                                  (errors.createProjectLeadWorkSheetPurchaserList?.[index]?.occupation && touched.createProjectLeadWorkSheetPurchaserList?.[index]?.occupation
                                                    ? ' is-invalid'
                                                    : '')
                                                }
                                                placeholder=""
                                              />
                                              <ErrorMessage
                                                name={`createProjectLeadWorkSheetPurchaserList.${index}.occupation`}
                                                component="div"
                                                className="invalid-feedback"
                                              />
                                            </FormGroup>
                                          </Col>
                                        </Row>
                                        <FieldArray name={`createProjectLeadWorkSheetPurchaserList.${index}.createProjectLeadWorkSheetPurchaserDocumentList`}>
                                          {(arrayHelpers) => (
                                            <div>
                                              <h5>Upload</h5>
                                              {purchaser.createProjectLeadWorkSheetPurchaserDocumentList.map((doc, docIndex) => (
                                                <Row key={docIndex}>
                                                  <Col sm="4">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor={`createProjectLeadWorkSheetPurchaserList.${index}.createProjectLeadWorkSheetPurchaserDocumentList.${docIndex}.documentTitle`}>
                                                        {this.props.t("Document Name")}
                                                      </Label>
                                                      <SafeField
                                                        name={`createProjectLeadWorkSheetPurchaserList.${index}.createProjectLeadWorkSheetPurchaserDocumentList.${docIndex}.documentTitle`}
                                                        type="text"
                                                        className={
                                                          "form-control" +
                                                          (errors[`createProjectLeadWorkSheetPurchaserList.${index}.createProjectLeadWorkSheetPurchaserDocumentList.${docIndex}.documentTitle`] &&
                                                            touched[`createProjectLeadWorkSheetPurchaserList.${index}.createProjectLeadWorkSheetPurchaserDocumentList.${docIndex}.documentTitle`]
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        placeholder=""
                                                      />
                                                      <ErrorMessage
                                                        name={`createProjectLeadWorkSheetPurchaserList.${index}.createProjectLeadWorkSheetPurchaserDocumentList.${docIndex}.documentTitle`}
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                                                  <Col sm="5">
                                                    <FormGroup className="mb-3" id="upload-box">
                                                      <div className="form-group mb-3">
                                                        <Label htmlFor={`createProjectLeadWorkSheetPurchaserList.${index}.createProjectLeadWorkSheetPurchaserDocumentList.${docIndex}.documentUrl`}>
                                                          {this.props.t("Upload Document")}
                                                        </Label>
                                                        <FileBase64
                                                          className="form-control"
                                                          multiple={false}
                                                          onDone={(file) => {
                                                            const fieldName = `createProjectLeadWorkSheetPurchaserList.${index}.createProjectLeadWorkSheetPurchaserDocumentList.${docIndex}.documentUrl`;
                                                            arrayHelpers.replace(docIndex, { ...doc, documentUrl: file.base64 });
                                                          }}

                                                        />
                                                      </div>
                                                    </FormGroup>
                                                  </Col>
                                                  <Col sm="2">
                                                    <button type="button" className="btn btn-add" style={{ marginTop: 30 }} onClick={() => arrayHelpers.remove(docIndex)}>
                                                      Remove
                                                    </button>
                                                  </Col>
                                                </Row>
                                              ))}
                                              <button type="button" className="btn btn-add" onClick={() => arrayHelpers.push({ fileName: '', file: '' })}>
                                                Add Document
                                              </button>
                                            </div>
                                          )}
                                        </FieldArray>
                                      </div>
                                    </Collapse>
                                  </div>
                                ))}
                              </>
                            )}
                          </FieldArray>


                        </div>
                      </Row>
                      <Row>
                        <Col sm="12">
                          <hr></hr>
                        </Col>

                        <Col sm="12">
                          <button
                            type="submit"
                            className="btn btn-add w-md  mt-27"

                          >
                            Submit
                          </button>
                        </Col>
                      </Row>

                    </Form>
                  )}
                </Formik>
              </OffcanvasBody>
            </Offcanvas>

            <Offcanvas
              isOpen={this.state.isUnitData}
              direction="end"
              toggle={this.toggleUnitCanvas}

            >
              <OffcanvasHeader toggle={this.toggleUnitCanvas}>
                Upload Unit
              </OffcanvasHeader>
              <OffcanvasBody>
                <Nav pills className="navtab-bg nav-justified">
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab2 === "4",
                      })}
                      onClick={() => {
                        this.toggle2("4");
                      }}
                    >
                      Unit Information
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab2 === "5",
                      })}
                      onClick={() => {
                        this.toggle2("5");
                      }}
                    >
                      New Unit
                    </NavLink>
                  </NavItem>


                </Nav>
                <TabContent
                  activeTab={this.state.activeTab2}
                  className="p-3 text-muted"
                >
                  <TabPane tabId="4">
                    <div className="tabContent">
                      <Formik
                        enableReinitialize={true}
                        initialValues={{
                          id: worksheetLead.id,
                          projectLeadWorkSheetId: worksheetLead.id,
                          unitStatusId: (unitdata?.unitStatusId) ? unitdata.unitStatusId : 1,
                          unitStatusText: (unitdata?.unitStatusText) ? unitdata.unitStatusText : 'Waiting for allocations',
                          unitNote: (unitdata?.unitNote) ? unitdata.unitNote : '',
                          allocationBy: parseInt(localStorage.getItem('userId')),
                          createProjectLeadWorkSheetAllocationList: worksheetUnitData && Array.isArray(worksheetUnitData)
                          ? worksheetUnitData.map((item) => ({
                              selectedOptionId: item?.id || null,
                              selectedOptionText: item?.optionNumber ? `${item.optionNumber}/${item.optionType}` : '',
                              unitCost: item?.unitCost || '',
                              insideSqFt: item?.insideSqFt || '',
                              outsideSqFt: item?.outsideSqFt || '',
                            })) : [],
                        }}
                        validationSchema={Yup.object().shape({
                          createProjectLeadWorkSheetAllocationList: Yup.array().of(
                            Yup.object().shape({
                              selectedOptionId: Yup.string().required('Selected option ID is required'),
                              insideSqFt: Yup.number().when('selectedOptionId', {
                                is: (val) => !!val,
                                then: Yup.number().required('Inside SqFt is required'),
                                otherwise: Yup.number()
                              }),
                              outsideSqFt: Yup.number().when('selectedOptionId', {
                                is: (val) => !!val,
                                then: Yup.number().required('Outside SqFt is required'),
                                otherwise: Yup.number()
                              }),
                              unitCost: Yup.number().when('selectedOptionId', {
                                is: (val) => !!val,
                                then: Yup.number().required('Cost SqFt is required'),
                                otherwise: Yup.number()
                              })
                            })
                          )

                        })}

                        onSubmit={(values) => {
                          const filteredList = this.removeEmptySheetAllocationList(values.createProjectLeadWorkSheetAllocationList);
                          const convertedList = filteredList.map(item => ({
                            ...item,
                            unitCost: parseInt(item.unitCost, 10) || 0,
                            insideSqFt: parseInt(item.insideSqFt, 10) || 0,
                            outsideSqFt: parseInt(item.outsideSqFt, 10) || 0,
                          }));

                          const allocationData = {
                            ...values,
                            createProjectLeadWorkSheetAllocationList: convertedList,
                          };
                          const obj = JSON.parse(localStorage.getItem("authUser"));
                          const token = obj.resultData.bearerToken;
                          const str = 'Bearer ' + token;
                          const headers = {
                            'Content-Type': 'application/json',
                            'Authorization': str
                          };

                          toast.loading("Please wait...");
                          axios.post('https://rscoreapi.azurewebsites.net/api/ProjectLeadWorkSheet/AddProjectLeadWorkSheetAllocation', allocationData, { headers })
                            .then(response => {
                              toast.dismiss();
                              if (response.data.success) {
                                toast.success("Unit Data Submitted");
                                
                              } else {
                                toast.warn(response.validationErrors[0]);
                              }
                            })
                            .catch(error => {
                              toast.dismiss();
                              console.error('Error:', error);
                            });
                        }}
                      >
                        {({ errors, touched, values, handleChange, handleBlur, setFieldValue }) => (
                          <Form
                            className="needs-validation"
                          >
                            <Row>

                              <Col md="12">
                                <FormGroup className="mb-3">


                                  <Input
                                    type="radio"
                                    id="customRadioInline1"
                                    name="unitStatusId"
                                    className="form-check-input mt-2"
                                    value="1"
                                    checked={values.unitStatusId === 1}
                                    onChange={(e) => {
                                      setFieldValue('unitStatusId', 1);
                                      setFieldValue('unitStatusText', 'Waiting for allocation');
                                    }}
                                  />
                                  <Label
                                    className="form-check-label ms-4"
                                    htmlFor="customRadioInline1"
                                  >
                                    <span className="">Waiting for allocation</span>
                                  </Label>
                                </FormGroup>
                              </Col>
                              <Col md="12">
                                <FormGroup className="mb-3">


                                  <Input
                                    type="radio"
                                    id="customRadioInline2"
                                    name="unitStatusId"
                                    className="form-check-input mt-2"
                                    value="2"
                                    checked={values.unitStatusId === 2}
                                    onChange={(e) => {
                                      setFieldValue('unitStatusId', 2);
                                      setFieldValue('unitStatusText', 'Unit Not allocated');
                                    }}
                                  />
                                  <Label
                                    className="form-check-label ms-4"
                                    htmlFor="customRadioInline2"
                                  >
                                    <span className="">Unit Not allocated</span>
                                  </Label>
                                </FormGroup>
                              </Col>
                              <Col md="12">
                                <FormGroup className="mb-3">


                                  <Input
                                    type="radio"
                                    id="customRadioInline3"
                                    name="unitStatusId"
                                    className="form-check-input mt-2"
                                    value="3"
                                    checked={values.unitStatusId === 3}
                                    onChange={(e) => {
                                      setFieldValue('unitStatusId', 3);
                                      setFieldValue('unitStatusText', 'Unit Allocated');
                                    }}
                                  />
                                  <Label
                                    className="form-check-label ms-4"
                                    htmlFor="customRadioInline3"
                                  >
                                    <span className="">Unit Allocated</span>
                                  </Label>
                                </FormGroup>
                              </Col>
                              <Col md="12">
                                <FormGroup className="mb-3">


                                  <Input
                                    type="radio"
                                    id="customRadioInline4"
                                    name="unitStatusId"
                                    className="form-check-input mt-2"
                                    value="4"
                                    checked={values.unitStatusId === 4}
                                    onChange={(e) => {
                                      setFieldValue('unitStatusId', 4);
                                      setFieldValue('unitStatusText', 'Withdrawn from client');
                                    }}
                                  />
                                  <Label
                                    className="form-check-label ms-4"
                                    htmlFor="customRadioInline4"
                                  >
                                    Withdrawn from client
                                  </Label>
                                </FormGroup>
                              </Col>
                            </Row>
                            {values.unitStatusId !== 1 && (
                              <>
                                <hr></hr>
                                {values.unitStatusId !== 2 && values.unitStatusId !== 4 && (
                                  <>
                                    <div id="Selchoice">
                                      <FieldArray name="createProjectLeadWorkSheetAllocationList">
                                        {({ insert, remove, push }) => (
                                          <>
                                           
                                           {map(worksheetUnitData, (unitData, unitkey) => {
                                           // Logs unitData to the console for debugging
                                          return (
                                                                                      
                                              <Row key={unitkey}>
                                                <Col md="12">
                                                  <div className="form-check mb-3">
                                                    <SafeField
                                                      className={`form-check-input` + unitData.id}
                                                      type="checkbox"
                                                      name={`createProjectLeadWorkSheetAllocationList.${unitkey}.selectedOptionId`}
                                                      value={values.createProjectLeadWorkSheetAllocationList[unitkey].selectedOptionId}
                                                      id={`defaultCheck${unitkey}`}
                                                  
                                                      onChange={(e) => {
                                                        const isChecked = e.target.checked;
                                                        const newValue = isChecked ? unitData.id : null;
                                                        const optionText = isChecked ? `${unitData.optionNumber}/${unitData.optionType}` : '';

                                                        setFieldValue(`createProjectLeadWorkSheetAllocationList.${unitkey}.selectedOptionId`, newValue);
                                                        setFieldValue(`createProjectLeadWorkSheetAllocationList.${unitkey}.selectedOptionText`, optionText);
                                                      }}

                                                      checked={
                                                        values.createProjectLeadWorkSheetAllocationList &&
                                                        values.createProjectLeadWorkSheetAllocationList[unitkey]?.selectedOptionId === unitData.id
                                                      }
                                                    />
                                                    <label
                                                      className="form-check-label"
                                                      id={`defaultCheck${unitkey}`}
                                                    >
                                                      {unitData.optionNumber}/{unitData.optionType}
                                                    </label>
                                                  </div>

                                                </Col>
                                                <Col md="4">
                                                  <FormGroup className="mb-3">
                                                    <Label htmlFor={`createProjectLeadWorkSheetAllocationList.${unitkey}.insideSqFt`}>
                                                      {this.props.t("Inside sq. ft.")}
                                                    </Label>
                                                    <SafeField
                                                      name={`createProjectLeadWorkSheetAllocationList.${unitkey}.insideSqFt`}
                                                      type="text"
                                                      className={`form-control${errors.createProjectLeadWorkSheetAllocationList &&
                                                          errors.createProjectLeadWorkSheetAllocationList[unitkey] &&
                                                          errors.createProjectLeadWorkSheetAllocationList[unitkey].insideSqFt &&
                                                          touched.createProjectLeadWorkSheetAllocationList &&
                                                          touched.createProjectLeadWorkSheetAllocationList[unitkey] &&
                                                          touched.createProjectLeadWorkSheetAllocationList[unitkey].insideSqFt
                                                          ? " is-invalid"
                                                          : ""
                                                        }`}
                                                    />
                                                    <ErrorMessage
                                                      name={`createProjectLeadWorkSheetAllocationList.${unitkey}.insideSqFt`}
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </FormGroup>
                                                </Col>
                                                <Col md="4">
                                                  <FormGroup className="mb-3">
                                                    <Label htmlFor={`createProjectLeadWorkSheetAllocationList.${unitkey}.outsideSqFt`}>
                                                      {this.props.t("Outside sq.ft")}
                                                    </Label>
                                                    <SafeField
                                                      name={`createProjectLeadWorkSheetAllocationList.${unitkey}.outsideSqFt`}
                                                      type="text"
                                                      onChange={handleChange}
                                                      className={`form-control${errors.createProjectLeadWorkSheetAllocationList &&
                                                          errors.createProjectLeadWorkSheetAllocationList[unitkey] &&
                                                          errors.createProjectLeadWorkSheetAllocationList[unitkey].outsideSqFt &&
                                                          touched.createProjectLeadWorkSheetAllocationList &&
                                                          touched.createProjectLeadWorkSheetAllocationList[unitkey] &&
                                                          touched.createProjectLeadWorkSheetAllocationList[unitkey].outsideSqFt
                                                          ? " is-invalid"
                                                          : ""
                                                        }`}
                                                    />
                                                    <ErrorMessage
                                                      name={`createProjectLeadWorkSheetAllocationList.${unitkey}.outsideSqFt`}
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </FormGroup>
                                                </Col>
                                                <Col md="4">
                                                  <FormGroup className="mb-3">
                                                    <Label htmlFor={`createProjectLeadWorkSheetAllocationList.${unitkey}.unitCost`}>
                                                      {this.props.t("Cost")}
                                                    </Label>
                                                    <SafeField
                                                      name={`createProjectLeadWorkSheetAllocationList.${unitkey}.unitCost`}
                                                      type="text"
                                                      onChange={handleChange}
                                                      className={`form-control${errors.createProjectLeadWorkSheetAllocationList &&
                                                          errors.createProjectLeadWorkSheetAllocationList[unitkey] &&
                                                          errors.createProjectLeadWorkSheetAllocationList[unitkey].unitCost &&
                                                          touched.createProjectLeadWorkSheetAllocationList &&
                                                          touched.createProjectLeadWorkSheetAllocationList[unitkey] &&
                                                          touched.createProjectLeadWorkSheetAllocationList[unitkey].unitCost
                                                          ? " is-invalid"
                                                          : ""
                                                        }`}
                                                    />
                                                    <ErrorMessage
                                                      name={`createProjectLeadWorkSheetAllocationList.${unitkey}.unitCost`}
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </FormGroup>
                                                </Col>
                                              </Row>
                                          )

                                        })}
                                          </>
                                        )}
                                      </FieldArray>
                                    </div>

                                  </>
                                )}
                                <Row id="noteRow">
                                  <Col md="12">
                                    <FormGroup className="mb-3">
                                      <Label htmlFor="unitNote">
                                        {this.props.t("Add Note")}
                                      </Label>
                                      <SafeField
                                        name="unitNote"
                                        onChange={handleChange}
                                        as="textarea"
                                        className={
                                          "form-control" +
                                          (errors.unitNote && touched.unitNote
                                            ? " is-invalid"
                                            : "")
                                        }
                                        id="unitNote"
                                      />
                                      <ErrorMessage
                                        name="unitNote"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </FormGroup>
                                  </Col>






                                </Row>
                              </>
                            )}
                            <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>
                          </Form>
                        )}
                      </Formik>


                    </div>
                  </TabPane>
                  <TabPane tabId="5">
                    <div className="tabContent">
                      <Formik
                        enableReinitialize={true}
                        initialValues={{
                          id: worksheetLead.id,
                          unitStatusId: 0,
                          unitStatusText: '',
                          unitNote: '',
                          allocationBy: parseInt(localStorage.getItem('userId')),
                          agentId: parseInt(localStorage.getItem('userId')),
                          createProjectLeadWorkSheetOptionList: [{
                            projectLeadWorkSheetId: worksheetLead.id,
                            optionNumber: '',
                            optionType: '',
                            optionNotes: '',
                            agentId: parseInt(localStorage.getItem('userId')),

                          }],
                          createProjectLeadWorkSheetAllocationList: [{
                            projectLeadWorkSheetId: worksheetLead.id,
                            unitCost: '',
                            insideSqFt: '',
                            outsideSqFt: ''
                          }]

                        }}
                        validationSchema={Yup.object().shape({

                          createProjectLeadWorkSheetOptionList: Yup.array().of(
                            Yup.object().shape({
                              optionNumber: Yup.string().required('This is required'),
                              optionType: Yup.string().required('This is required'),
                              optionNotes: Yup.string().required('This is required'),
                            })
                          ),
                          createProjectLeadWorkSheetAllocationList: Yup.array().of(
                            Yup.object().shape({
                              unitCost: Yup.number().required('Unit Cost is required'),
                              insideSqFt: Yup.number().required('Inside SqFt is required'),
                              outsideSqFt: Yup.number().required('Outside SqFt is required'),
                            })
                          ),
                        })}
                        onSubmit={(values) => {
                          //
                          const filterList = values.createProjectLeadWorkSheetAllocationList;
                          const convertedList = filterList.map(item => ({
                            ...item,
                            unitCost: parseInt(item.unitCost, 10) || 0,
                            insideSqFt: parseInt(item.insideSqFt, 10) || 0,
                            outsideSqFt: parseInt(item.outsideSqFt, 10) || 0,

                          }));
                          const allocationData = {
                            ...values,
                            createProjectLeadWorkSheetAllocationList: convertedList,
                          };
                          const obj = JSON.parse(localStorage.getItem("authUser"));
                          const token = obj.resultData.bearerToken;
                          const str = 'Bearer ' + token;
                          const headers = {
                            'Content-Type': 'application/json',
                            'Authorization': str
                          };

                          toast.loading("Please wait...");
                          axios.post('https://rscoreapi.azurewebsites.net/api/ProjectLeadWorkSheet/AddProjectLeadWorkSheetUnit', allocationData, { headers })
                            .then(response => {
                              toast.dismiss();
                              if (response.data.success) {
                                toast.success("New Unit Added");
                                
                              } else {
                                toast.warn(response.validationErrors[0]);
                              }
                            })
                            .catch(error => {
                              toast.dismiss();
                              console.error('Error:', error);
                            });

                          
                        }}
                      >
                        {({
                          errors,
                          touched,
                          values,
                          handleChange,
                          setFieldValue,
                        }) => (
                          <Form className="needs-validation">

                            <Row>
                              <h4>Choice 1</h4>
                              <FieldArray name="createProjectLeadWorkSheetOptionList">
                                {({ insert, remove, push }) => (
                                  <>
                                    {values.createProjectLeadWorkSheetOptionList.length > 0 &&
                                      values.createProjectLeadWorkSheetOptionList.map((option, index) => (
                                        <div className="row" key={index}>
                                          <Col sm="4">
                                            <FormGroup className="mb-3">
                                              <Label htmlFor={`createProjectLeadWorkSheetOptionList.${index}.optionNumber`}>
                                                {this.props.t("Model Name")}
                                              </Label>
                                              <SafeField
                                                name={`createProjectLeadWorkSheetOptionList.${index}.optionNumber`}
                                                type="text"
                                                className={
                                                  "form-control" +
                                                  (errors.createProjectLeadWorkSheetOptionList &&
                                                    errors.createProjectLeadWorkSheetOptionList[index] &&
                                                    errors.createProjectLeadWorkSheetOptionList[index].optionNumber &&
                                                    touched.createProjectLeadWorkSheetOptionList &&
                                                    touched.createProjectLeadWorkSheetOptionList[index] &&
                                                    touched.createProjectLeadWorkSheetOptionList[index].optionNumber
                                                    ? " is-invalid"
                                                    : "")
                                                }
                                                id={`createProjectLeadWorkSheetOptionList.${index}.optionNumber`}
                                                placeholder=""
                                              />
                                              <ErrorMessage
                                                name={`createProjectLeadWorkSheetOptionList.${index}.optionNumber`}
                                                component="div"
                                                className="invalid-feedback"
                                              />
                                            </FormGroup>
                                          </Col>

                                          <Col sm="4">
                                            <Label htmlFor={`createProjectLeadWorkSheetOptionList.${index}.optionType`}>
                                              {this.props.t("Bedroom Type")}
                                            </Label>
                                            <FormGroup className="mb-3">
                                              <SafeField
                                                name={`createProjectLeadWorkSheetOptionList.${index}.optionType`}
                                                type="text"
                                                className={
                                                  "form-control" +
                                                  (errors.createProjectLeadWorkSheetOptionList &&
                                                    errors.createProjectLeadWorkSheetOptionList[index] &&
                                                    errors.createProjectLeadWorkSheetOptionList[index].optionType &&
                                                    touched.createProjectLeadWorkSheetOptionList &&
                                                    touched.createProjectLeadWorkSheetOptionList[index] &&
                                                    touched.createProjectLeadWorkSheetOptionList[index].optionType
                                                    ? " is-invalid"
                                                    : "")
                                                }
                                                placeholder=""
                                                id={`createProjectLeadWorkSheetOptionList.${index}.optionType`}
                                              />
                                              <ErrorMessage
                                                name={`createProjectLeadWorkSheetOptionList.${index}.optionType`}
                                                component="div"
                                                className="invalid-feedback"
                                              />
                                            </FormGroup>
                                          </Col>

                                          <Col sm="4">
                                            <Label htmlFor={`createProjectLeadWorkSheetOptionList.${index}.optionNotes`}>
                                              {this.props.t("Note")}
                                            </Label>
                                            <FormGroup className="mb-3">
                                              <SafeField
                                                name={`createProjectLeadWorkSheetOptionList.${index}.optionNotes`}
                                                type="text"
                                                className={
                                                  "form-control" +
                                                  (errors.createProjectLeadWorkSheetOptionList &&
                                                    errors.createProjectLeadWorkSheetOptionList[index] &&
                                                    errors.createProjectLeadWorkSheetOptionList[index].optionNotes &&
                                                    touched.createProjectLeadWorkSheetOptionList &&
                                                    touched.createProjectLeadWorkSheetOptionList[index] &&
                                                    touched.createProjectLeadWorkSheetOptionList[index].optionNotes
                                                    ? " is-invalid"
                                                    : "")
                                                }
                                                placeholder=""
                                                id={`createProjectLeadWorkSheetOptionList.${index}.optionNotes`}
                                              />
                                              <ErrorMessage
                                                name={`createProjectLeadWorkSheetOptionList.${index}.optionNotes`}
                                                component="div"
                                                className="invalid-feedback"
                                              />
                                            </FormGroup>
                                          </Col>
                                        </div>
                                      ))}
                                  </>
                                )}
                              </FieldArray>
                              <FieldArray name="createProjectLeadWorkSheetAllocationList">
                                {({ insert, remove, push }) => (
                                  <>
                                    {values.createProjectLeadWorkSheetAllocationList.length > 0 &&
                                      values.createProjectLeadWorkSheetAllocationList.map((option, index) => (
                                        <div className="row" key={index}>
                                          <Col sm="4">
                                            <FormGroup className="mb-3">
                                              <Label htmlFor={`createProjectLeadWorkSheetAllocationList.${index}.insideSqFt`}>
                                                {this.props.t("Inside sq. ft.")}
                                              </Label>
                                              <SafeField
                                                name={`createProjectLeadWorkSheetAllocationList.${index}.insideSqFt`}
                                                type="text"
                                                className={
                                                  "form-control" +
                                                  (errors.createProjectLeadWorkSheetAllocationList &&
                                                    errors.createProjectLeadWorkSheetAllocationList[index] &&
                                                    errors.createProjectLeadWorkSheetAllocationList[index].insideSqFt &&
                                                    touched.createProjectLeadWorkSheetAllocationList &&
                                                    touched.createProjectLeadWorkSheetAllocationList[index] &&
                                                    touched.createProjectLeadWorkSheetAllocationList[index].insideSqFt
                                                    ? " is-invalid"
                                                    : "")
                                                }
                                                id={`createProjectLeadWorkSheetAllocationList.${index}.insideSqFt`}
                                                placeholder=""
                                              />
                                              <ErrorMessage
                                                name={`createProjectLeadWorkSheetAllocationList.${index}.insideSqFt`}
                                                component="div"
                                                className="invalid-feedback"
                                              />
                                            </FormGroup>
                                          </Col>

                                          <Col sm="4">
                                            <Label htmlFor={`createProjectLeadWorkSheetAllocationList.${index}.outsideSqFt`}>
                                              {this.props.t("Outside sq.ft")}
                                            </Label>
                                            <FormGroup className="mb-3">
                                              <SafeField
                                                name={`createProjectLeadWorkSheetAllocationList.${index}.outsideSqFt`}
                                                type="text"
                                                className={
                                                  "form-control" +
                                                  (errors.createProjectLeadWorkSheetAllocationList &&
                                                    errors.createProjectLeadWorkSheetAllocationList[index] &&
                                                    errors.createProjectLeadWorkSheetAllocationList[index].outsideSqFt &&
                                                    touched.createProjectLeadWorkSheetAllocationList &&
                                                    touched.createProjectLeadWorkSheetAllocationList[index] &&
                                                    touched.createProjectLeadWorkSheetAllocationList[index].outsideSqFt
                                                    ? " is-invalid"
                                                    : "")
                                                }
                                                placeholder=""
                                                id={`createProjectLeadWorkSheetAllocationList.${index}.outsideSqFt`}
                                              />
                                              <ErrorMessage
                                                name={`createProjectLeadWorkSheetAllocationList.${index}.outsideSqFt`}
                                                component="div"
                                                className="invalid-feedback"
                                              />
                                            </FormGroup>
                                          </Col>

                                          <Col sm="4">
                                            <Label htmlFor={`createProjectLeadWorkSheetAllocationList.${index}.unitCost`}>
                                              {this.props.t("Cost")}
                                            </Label>
                                            <FormGroup className="mb-3">
                                              <SafeField
                                                name={`createProjectLeadWorkSheetAllocationList.${index}.unitCost`}
                                                type="text"
                                                className={
                                                  "form-control" +
                                                  (errors.createProjectLeadWorkSheetAllocationList &&
                                                    errors.createProjectLeadWorkSheetAllocationList[index] &&
                                                    errors.createProjectLeadWorkSheetAllocationList[index].unitCost &&
                                                    touched.createProjectLeadWorkSheetAllocationList &&
                                                    touched.createProjectLeadWorkSheetAllocationList[index] &&
                                                    touched.createProjectLeadWorkSheetAllocationList[index].unitCost
                                                    ? " is-invalid"
                                                    : "")
                                                }
                                                placeholder=""
                                                id={`createProjectLeadWorkSheetAllocationList.${index}.unitCost`}
                                              />
                                              <ErrorMessage
                                                name={`createProjectLeadWorkSheetAllocationList.${index}.unitCost`}
                                                component="div"
                                                className="invalid-feedback"
                                              />
                                            </FormGroup>
                                          </Col>
                                        </div>
                                      ))}
                                  </>
                                )}
                              </FieldArray>
                            </Row>

                            <Row>
                              <Col sm="12">
                                <hr></hr>
                              </Col>

                              <Col sm="12">
                                <button
                                  type="submit"
                                  className="btn btn-danger danger w-md  mt-27"
                                >
                                  Submit
                                </button>
                              </Col>
                            </Row>

                          </Form>
                        )}
                      </Formik>
                    </div>
                  </TabPane>



                </TabContent>


              </OffcanvasBody>
            </Offcanvas>
            <Offcanvas
          isOpen={this.state.isRight}
          direction="end"
          toggle={this.toggleEmailCanvas}
          
        >
          <OffcanvasHeader toggle={this.toggleEmailCanvas}>
            All Activities
          </OffcanvasHeader>
          <OffcanvasBody>
          <ul className="verti-timeline list-unstyled">
                                        {map(
                                          activities,
                                          (allactivity, allactkey) => (
                                            <li
                                              className="event-list eventlist"
                                              key={"_allact_" + allactkey}
                                            >
                                              <div className="event-timeline-dot">
                                                {(() => {
                                                  if (
                                                    allactivity.activitySubType ==
                                                      8 ||
                                                    allactivity.activitySubType ==
                                                      9 ||
                                                    allactivity.activitySubType ==
                                                      7
                                                  ) {
                                                    return (
                                                      <>
                                                        <img src={emaillog} />
                                                      </>
                                                    );
                                                  } else if (
                                                    allactivity.activitySubType ==
                                                      3 ||
                                                    allactivity.activitySubType ==
                                                      4 ||
                                                    allactivity.activitySubType ==
                                                      5
                                                  ) {
                                                    return (
                                                      <>
                                                        <img src={phonelog} />
                                                      </>
                                                    );
                                                  } else if (
                                                    allactivity.activitySubType ==
                                                    10
                                                  ) {
                                                    return (
                                                      <>
                                                        <img src={follow} />
                                                      </>
                                                    );
                                                  } else {
                                                    return (
                                                      <>
                                                        <img src={notes} />
                                                      </>
                                                    );
                                                  }
                                                })()}
                                              </div>
                                              <div className="d-flex">
                                                <div className="flex-shrink-0 me-3">
                                                  <h5 className="font-size-14">
                                                    <Moment format="D MMM YY">
                                                      {allactivity.addedDate}
                                                    </Moment>
                                                  </h5>
                                                </div>
                                                <div className="flex-grow-1">
                                                  <h5 className="font-size-14">
                                                    {
                                                      localization[
                                                        "ActivitySubType_" +
                                                          allactivity.activityType +
                                                          "_" +
                                                          allactivity.activitySubType
                                                      ]
                                                    }
                                                  </h5>
                                                </div>
                                              </div>
                                              <div className="exNote">
                                                {allactivity.activityRemarks}
                                              </div>
                                            </li>
                                          )
                                        )}
          </ul>
          </OffcanvasBody>
        </Offcanvas>

        <Offcanvas
          isOpen={this.state.isRight}
          direction="end"
          toggle={this.toggleEmailCanvas}
          
        >
          <OffcanvasHeader toggle={this.toggleEmailCanvas}>
            All Activities
          </OffcanvasHeader>
          <OffcanvasBody>
          <ul className="verti-timeline list-unstyled">
                                        {map(
                                          activities,
                                          (allactivity, allactkey) => (
                                            <li
                                              className="event-list eventlist"
                                              key={"_allact_" + allactkey}
                                            >
                                              <div className="event-timeline-dot">
                                                {(() => {
                                                  if (
                                                    allactivity.activitySubType ==
                                                      8 ||
                                                    allactivity.activitySubType ==
                                                      9 ||
                                                    allactivity.activitySubType ==
                                                      7
                                                  ) {
                                                    return (
                                                      <>
                                                        <img src={emaillog} />
                                                      </>
                                                    );
                                                  } else if (
                                                    allactivity.activitySubType ==
                                                      3 ||
                                                    allactivity.activitySubType ==
                                                      4 ||
                                                    allactivity.activitySubType ==
                                                      5
                                                  ) {
                                                    return (
                                                      <>
                                                        <img src={phonelog} />
                                                      </>
                                                    );
                                                  } else if (
                                                    allactivity.activitySubType ==
                                                    10
                                                  ) {
                                                    return (
                                                      <>
                                                        <img src={follow} />
                                                      </>
                                                    );
                                                  } else {
                                                    return (
                                                      <>
                                                        <img src={notes} />
                                                      </>
                                                    );
                                                  }
                                                })()}
                                              </div>
                                              <div className="d-flex">
                                                <div className="flex-shrink-0 me-3">
                                                  <h5 className="font-size-14">
                                                    <Moment format="D MMM YY">
                                                      {allactivity.addedDate}
                                                    </Moment>
                                                  </h5>
                                                </div>
                                                <div className="flex-grow-1">
                                                  <h5 className="font-size-14">
                                                    {
                                                      localization[
                                                        "ActivitySubType_" +
                                                          allactivity.activityType +
                                                          "_" +
                                                          allactivity.activitySubType
                                                      ]
                                                    }
                                                  </h5>
                                                </div>
                                              </div>
                                              <div className="exNote">
                                                {allactivity.activityRemarks}
                                              </div>
                                            </li>
                                          )
                                        )}
          </ul>
          </OffcanvasBody>
        </Offcanvas>

     
    
      
        <Offcanvas
          isOpen={this.state.isCallLog}
          direction="end"
          toggle={this.toggleCallLogCanvas}
          style={{ width: 800 }}
        >
          <OffcanvasHeader toggle={this.toggleCallLogCanvas}>
            Call Log
          </OffcanvasHeader>
          <OffcanvasBody>
            <Formik
              enableReinitialize={true}
              initialValues={{
                actionType: '',
                addedDate: new Date(),
                refId: worksheetLead.leadId


              }}
              validationSchema={Yup.object().shape({
                actionType: Yup.string().required(
                  "Please Select Action"
                )
              })}

              onSubmit={values => {

                if (isEditCall) {
                   
                  onAddCallLog(values)
                    //onAddLeadNote(updateData);
                } else {

                }
                this.toggleCallLog();
            }}
            >
              {({ errors, touched, values, handleChange, setFieldValue }) => (
                <Form
                  className="needs-validation"
                >

                  <Row className="mt20 mb20">



                    <Col lg="12">
                      <div role="group" className="btnCheckGroup" aria-labelledby="my-radio-group">
                        <label>
                          <SafeField type="radio" name="actionType" id="actionType1" value="No Answer" onChange={handleChange} />
                          No Answer
                        </label>
                        <label>
                          <SafeField type="radio" name="actionType" id="actionType2" value="Left Voicemail" onChange={handleChange} />
                          Left Voicemail
                        </label>
                        <label>
                          <SafeField type="radio" name="actionType" id="actionType2" value="Bad Number" onChange={handleChange} />
                          Bad Number
                        </label>

                      </div>
                      <ErrorMessage
                          name="actionType"
                          component="div"
                          className="invalid-feedback"
                        />  

                    </Col>

                  </Row>
                  <Row>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="addedDate">
                          Log Date
                        </Label>
                        <Flatpickr
                          className={
                            "form-control" +
                            (errors.addedDate && touched.addedDate
                              ? " is-invalid"
                              : "")
                          }
                          placeholder=""
                          value={values.addedDate}
                          onChange={(value) => setFieldValue('addedDate', value[0])}
                          options={{
                            altInput: true,
                            altFormat: "F j, Y",
                            dateFormat: "Y-m-d"
                          }}
                        />
                        <ErrorMessage
                          name="addedDate"
                          component="div"
                          className="invalid-feedback"
                        />

                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="callNote">
                          Add Message (Optional)
                        </Label>
                        <textarea
                          name="callNote"
                          onChange={handleChange}
                          type="textarea"

                          className="form-control"

                          id="callNote"

                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>


                </Form>
              )}
            </Formik>
            <div className="mb-5 h4 card-title mt-20">Call Log History</div>
                                <ul className="verti-timeline list-unstyled">

                                  {map(calllogs, (callLog, callkey) => (

                                    <li className="event-list eventlist" key={"_call_" + callkey}>
                                      <div className="event-timeline-dot">
                                        <i className="bx bx-right-arrow-circle font-size-18" />
                                      </div>
                                      <div className="d-flex">
                                        <div className="flex-shrink-0 me-3">
                                          <h5 className="font-size-14">
                                            <Moment format="D MMM YY">{callLog.addedDate}</Moment>

                                            <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                                          </h5>
                                        </div>
                                        <div className="flex-grow-1">
                                          <h5 className="font-size-14">{localization["ActivitySubType_"+ callLog.activityType+"_"+callLog.activitySubType]}</h5>
                                        </div>
                                      </div>
                                      <div className="exNote">{callLog.activityRemarks}</div>
                                    </li>
                                  ))}

                                </ul>               
          </OffcanvasBody>
        </Offcanvas>

        


      


        <Offcanvas
          isOpen={this.state.isSmsLog}
          direction="end"
          toggle={this.toggleSmsLogCanvas}
          style={{ width: 800 }}
        >
          <OffcanvasHeader toggle={this.toggleSmsLogCanvas}>
            SMS Log
          </OffcanvasHeader>
          <OffcanvasBody>
            <Formik
              enableReinitialize={true}
              initialValues={{
                logDate: new Date(),


              }}
              validationSchema={Yup.object().shape({
                actionType: Yup.string().required(
                  "Please Select Action"
                )
              })}

              onSubmit={this.handleLeadEmailSubmit}
            >
              {({ errors, touched, values, handleChange, setFieldValue }) => (
                <Form
                  className="needs-validation"
                >

                  <Row className="mt20 mb20">



                    <Col lg="12">
                      <div role="group" className="btnCheckGroup" aria-labelledby="my-radio-group">
                        <label>
                          <SafeField type="radio" name="actionType" id="actionType1" value="SMS Sent" onChange={handleChange} />
                          SMS Sent
                        </label>
                        <label>
                          <SafeField type="radio" name="actionType" id="actionType2" value="SMS Received" onChange={handleChange} />
                          SMS Received
                        </label>
                        <label>
                          <SafeField type="radio" name="actionType" id="actionType2" value="SMS Bounced" onChange={handleChange} />
                          SMS Bounced
                        </label>

                      </div>

                    </Col>

                  </Row>
                  <Row>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="logDate">
                          Log Date
                        </Label>
                        <Flatpickr
                          className={
                            "form-control" +
                            (errors.logDate && touched.logDate
                              ? " is-invalid"
                              : "")
                          }
                          placeholder=""
                          value={values.logDate}
                          onChange={(value) => setFieldValue('logDate', value[0])}
                          options={{
                            altInput: true,
                            altFormat: "F j, Y",
                            dateFormat: "Y-m-d"
                          }}
                        />
                        <ErrorMessage
                          name="logDate"
                          component="div"
                          className="invalid-feedback"
                        />

                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="smsNote">
                          Add Message (Optional)
                        </Label>
                        <textarea
                          name="smsNote"
                          onChange={handleChange}
                          type="textarea"

                          className="form-control"

                          id="smsNote"

                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>


                </Form>
              )}
            </Formik>
          </OffcanvasBody>
        </Offcanvas>
   <Offcanvas
          isOpen={this.state.isMessage}
          direction="end"
          toggle={this.toggleMessageCanvas}
        >
          <OffcanvasHeader toggle={this.toggleMessageCanvas}>
            Message
          </OffcanvasHeader>
          <OffcanvasBody>
            <Formik
              enableReinitialize={true}
              initialValues={{

                //refId: lead.leadId,
                addMessage: (this.state && this.state.addMessage) || "",
              


              }}
              validationSchema={Yup.object().shape({
                addMessage: Yup.string().required("This is Required")
              })}

              onSubmit=""
            >
              {({ errors, touched, values, handleChange, setFieldValue }) => (
                <Form
                  className="needs-validation"
                >

                  <Row>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="addNote">
                          {this.props.t("Send Message")}
                        </Label>
                        <textarea
                          name="addMessage"
                          onChange={handleChange}
                          type="textarea"
                          className={
                            "form-control" +
                            (errors.addMessage && touched.addMessage
                              ? " is-invalid"
                              : "")
                          }
                          id="addMessage"
                        />
                        <ErrorMessage
                          name="addMessage"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <div className="clearfix"><button type="submit" className="btn btn-primary w-md">{this.props.t("Send")}</button></div>


                </Form>
              )}
            </Formik>
            <div className="mb-5 h4 card-title mt-20">Message History</div>
                              
          </OffcanvasBody>
        </Offcanvas>

          </Container>
        </div>

<       Modal size="lg" isOpen={this.state.showModal} toggle={this.toggleModal}>
          <ModalHeader toggle={this.toggleModal}>
            Print Preview

            
          </ModalHeader>
          <ModalBody>
           <Button color="primary float-end" onClick={this.handlePrint}>Print</Button>{' '}
            <div id="print-content">
               {map(worksheetPurData, (purData, purkey) => (
                        <>
                            <h4>Purchaser Detail</h4>
                          <h5>Purchaser {purkey + 1}</h5>
                          <div className="table-responsive">
                            <Table className="table table-sm m-0">

                              <tbody>
                                <tr>
                                  <th scope="row">Name</th>
                                  <td>{purData.firstName + " " + purData.lastName}</td>

                                </tr>
                                <tr>
                                  <th scope="row">Address</th>
                                  <td>{purData.address}</td>
                                </tr>
                                <tr>
                                  <th scope="row">City</th>
                                  <td>{purData.city}</td>

                                </tr>
                                <tr>
                                  <th scope="row">Province</th>
                                  <td>{purData.province}</td>

                                </tr>
                                <tr>
                                  <th scope="row">Phone</th>
                                  <td>{purData.homePhone}</td>

                                </tr>
                                <tr>
                                  <th scope="row">Cell</th>
                                  <td>{purData.cellPhone}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Email</th>
                                  <td>{purData.email}</td>

                                </tr>
                                <tr>
                                  <th scope="row">Birth Date</th>
                                  <td>{purData.birthDate ? <Moment format="D MMM YY">{purData.birthDate}</Moment> : ''}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Drivers License</th>
                                  <td>{purData.driversLicense}</td>

                                </tr>
                                <tr>
                                  <th scope="row">Occupation</th>
                                  <td>{purData.occupation}</td>
                                </tr>

                              </tbody>
                            </Table>
                          </div>
                          <h4>Unit Choices Detail</h4>
                             <div className="table-responsive">
                                                  <Table className="table table-sm m-0">
                          
                                                    <tbody>
                                                     
                                                      {map(worksheetUnitData, (unitData, unitkey) => (
                                                        <>
                                                          <tr>
                                                            <th scope="row">Choice {unitkey + 1}</th>
                                                            <td>Model: {unitData.optionNumber} {" "} Type: {unitData.optionType}</td>
                          
                          
                                                          </tr>
                                                          <tr>
                                                            <td colSpan="2">Notes: {unitData.optionNotes}</td>
                                                          </tr>
                                                        </>
                                                      ))}
                          
                          
                                                    </tbody>
                                                  </Table>
                                                </div>
                          <p>{" "}</p>
                            <div className="table-responsive">
                           
                           
                                                   <h4>Document Detail</h4>
                                                   <Table className="table table-sm m-0">
                           
                                                     <tbody>
                                                       {map(worksheetDocData, (docData, dockey) => (
                                                         <tr>
                                                           <th scope="row">{dockey + 1}</th>
                                                           <td>{docData.documentTitle}</td>
                                                          
                                                         </tr>
                                                       ))}
                                                     </tbody>
                                                   </Table>
                                       </div>                               
                        
                        </>
                      ))}
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.handlePrint}>Print</Button>{' '}
            <Button color="secondary" onClick={this.toggleModal}>Cancel</Button>
          </ModalFooter>
        </Modal>
     
      </React.Fragment>
    )
  }
}

projectSrr.propTypes = {
  t: PropTypes.any,
  match: PropTypes.object,
  loading: PropTypes.object,
  ongetProjectUUIDAction: PropTypes.func,
  projectData: PropTypes.object,
  className: PropTypes.any,
  worksheetLeads: PropTypes.array,
  onGetProjectWorksheetLead: PropTypes.func,
  onGetProjectWorksheetLeadPurDetail: PropTypes.func,
  onGetProjectWorksheetLeadUnitDetail: PropTypes.func,
  onGetProjectWorksheetLeadDocDetail: PropTypes.func,
  worksheetPurData: PropTypes.array,
  worksheetUnitData: PropTypes.array,
  worksheetDocData: PropTypes.array,
  onGetProjectWorksheetUnitinfo: PropTypes.func,
  unitdata: PropTypes.object,
  onGetAllActLead: PropTypes.func,
  activities: PropTypes.array,
  onAddLeadNote: PropTypes.func,
  onGetNoteLead:PropTypes.func,
  notes:PropTypes.array,
  onGetFollowLead:PropTypes.func,
  followups:PropTypes.array,
  onAddLeadFollowUp:PropTypes.func,
  onGetLeadEmailLog:PropTypes.func,
  onGetLeadCallLog:PropTypes.func,
  calllogs:PropTypes.array,
  emaillogs:PropTypes.array,
  onAddCallLog:PropTypes.func,
  onAddEmailLog:PropTypes.func,
  leadFollows:PropTypes.array,
  isResponsive:PropTypes.object,
  location:PropTypes.object,
  history:PropTypes.object
}
const mapStateToProps = ({ Project, projectleads }) => (
  {
    projectData: Project.projectData,
    worksheetLeads: Project.worksheetLeads,
    loading: Project.loading,
    worksheetPurData: Project.worksheetPurData,
    worksheetUnitData: Project.worksheetUnitData,
    worksheetDocData: Project.worksheetDocData,
    unitdata: Project.unitdata,
    activities:projectleads.activities,
    followups: projectleads.followups,
    notes: projectleads.notes,
    calllogs:projectleads.calllogs,
    emaillogs:projectleads.emaillogs,
    leadFollows:projectleads.leadFollows
  })
const mapDispatchToProps = dispatch => ({
  ongetProjectUUIDAction: (id) => dispatch(getProjectUUIDAction(id)),
  onGetProjectWorksheetLead: (projectId, statusId) => dispatch(getProjectWorksheetLead(projectId, statusId)),
  onGetProjectWorksheetLeadPurDetail: (id) => dispatch(getProjectWorksheetLeadPurDetail(id)),
  onGetProjectWorksheetLeadUnitDetail: (id) => dispatch(getProjectWorksheetLeadUnitDetail(id)),
  onGetProjectWorksheetLeadDocDetail: (id) => dispatch(getProjectWorksheetLeadDocDetail(id)),
  onGetProjectWorksheetUnitinfo: (id) => dispatch(getProjectWorksheetUnitinfo(id)),
  
  onAddLeadFollowUp:(data) => dispatch(addActivityProjectFollowUp(data)),
  onGetAllActLead:(leadId, projectGuid) => dispatch(getProjectLeadAct(leadId, projectGuid)),
  onGetFollowLead: (leadId, projectGuid) => dispatch(getActivityProjectFollowUp(leadId, projectGuid)),
  onAddLeadNote: (data) => dispatch(addProjectLeadNote(data)),
  onGetNoteLead: (leadId, projectGuid) => dispatch(getProjectLeadNote(leadId, projectGuid)),
  onAddCallLog:(data) => dispatch(addProjectLeadCallLog(data)),
  onGetLeadCallLog:(leadId, projectGuid) => dispatch(getProjectLeadCallLog(leadId, projectGuid)),
  onAddEmailLog:(data) => dispatch(addProjectLeadEmailLog(data)),
  onGetLeadEmailLog:(leadId, projectGuid) => dispatch(getProjectLeadEmailLog(leadId, projectGuid)),


});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslation()(projectSrr)))
